(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[77,14,22,81,82,84,85],{

/***/ "+567":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("y8Bd"), __webpack_require__("F0eJ"), __webpack_require__("fcsG"), __webpack_require__("F2+K"), __webpack_require__("bGGS"), __webpack_require__("eQk5"), __webpack_require__("aabA"), __webpack_require__("NYLY"), __webpack_require__("q1tI"), __webpack_require__("17x9"), __webpack_require__("i8i4"), __webpack_require__("qVQj"), __webpack_require__("WVtz")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _GoogleApiComponent, _Marker, _InfoWindow, _HeatMap, _Polygon, _Polyline, _Circle, _Rectangle, _react, _propTypes, _reactDom, _String, _cancelablePromise) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Map = exports.Rectangle = exports.Circle = exports.Polyline = exports.Polygon = exports.HeatMap = exports.InfoWindow = exports.Marker = exports.GoogleApiWrapper = undefined;
  Object.defineProperty(exports, 'GoogleApiWrapper', {
    enumerable: true,
    get: function () {
      return _GoogleApiComponent.wrapper;
    }
  });
  Object.defineProperty(exports, 'Marker', {
    enumerable: true,
    get: function () {
      return _Marker.Marker;
    }
  });
  Object.defineProperty(exports, 'InfoWindow', {
    enumerable: true,
    get: function () {
      return _InfoWindow.InfoWindow;
    }
  });
  Object.defineProperty(exports, 'HeatMap', {
    enumerable: true,
    get: function () {
      return _HeatMap.HeatMap;
    }
  });
  Object.defineProperty(exports, 'Polygon', {
    enumerable: true,
    get: function () {
      return _Polygon.Polygon;
    }
  });
  Object.defineProperty(exports, 'Polyline', {
    enumerable: true,
    get: function () {
      return _Polyline.Polyline;
    }
  });
  Object.defineProperty(exports, 'Circle', {
    enumerable: true,
    get: function () {
      return _Circle.Circle;
    }
  });
  Object.defineProperty(exports, 'Rectangle', {
    enumerable: true,
    get: function () {
      return _Rectangle.Rectangle;
    }
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var mapStyles = {
    container: {
      position: 'absolute',
      width: '100%',
      height: '100%'
    },
    map: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0
    }
  };

  var evtNames = ['ready', 'click', 'dragend', 'recenter', 'bounds_changed', 'center_changed', 'dblclick', 'dragstart', 'heading_change', 'idle', 'maptypeid_changed', 'mousemove', 'mouseout', 'mouseover', 'projection_changed', 'resize', 'rightclick', 'tilesloaded', 'tilt_changed', 'zoom_changed'];

  var Map = exports.Map = function (_React$Component) {
    _inherits(Map, _React$Component);

    function Map(props) {
      _classCallCheck(this, Map);

      var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

      if (!props.hasOwnProperty('google')) {
        throw new Error('You must include a `google` prop');
      }

      _this.listeners = {};
      _this.state = {
        currentLocation: {
          lat: _this.props.initialCenter.lat,
          lng: _this.props.initialCenter.lng
        }
      };

      _this.mapRef = _react2.default.createRef();
      return _this;
    }

    _createClass(Map, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (this.props.centerAroundCurrentLocation) {
          if (navigator && navigator.geolocation) {
            this.geoPromise = (0, _cancelablePromise.makeCancelable)(new Promise(function (resolve, reject) {
              navigator.geolocation.getCurrentPosition(resolve, reject);
            }));

            this.geoPromise.promise.then(function (pos) {
              var coords = pos.coords;
              _this2.setState({
                currentLocation: {
                  lat: coords.latitude,
                  lng: coords.longitude
                }
              });
            }).catch(function (e) {
              return e;
            });
          }
        }
        this.loadMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevProps.google !== this.props.google) {
          this.loadMap();
        }
        if (this.props.visible !== prevProps.visible) {
          this.restyleMap();
        }
        if (this.props.zoom !== prevProps.zoom) {
          this.map.setZoom(this.props.zoom);
        }
        if (this.props.center !== prevProps.center) {
          this.setState({
            currentLocation: this.props.center
          });
        }
        if (prevState.currentLocation !== this.state.currentLocation) {
          this.recenterMap();
        }
        if (this.props.bounds && this.props.bounds !== prevProps.bounds) {
          this.map.fitBounds(this.props.bounds);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var google = this.props.google;

        if (this.geoPromise) {
          this.geoPromise.cancel();
        }
        Object.keys(this.listeners).forEach(function (e) {
          google.maps.event.removeListener(_this3.listeners[e]);
        });
      }
    }, {
      key: 'loadMap',
      value: function loadMap() {
        var _this4 = this;

        if (this.props && this.props.google) {
          var google = this.props.google;

          var maps = google.maps;

          var mapRef = this.mapRef.current;
          var node = _reactDom2.default.findDOMNode(mapRef);
          var curr = this.state.currentLocation;
          var center = new maps.LatLng(curr.lat, curr.lng);

          var mapTypeIds = this.props.google.maps.MapTypeId || {};
          var mapTypeFromProps = String(this.props.mapType).toUpperCase();

          var mapConfig = Object.assign({}, {
            mapTypeId: mapTypeIds[mapTypeFromProps],
            center: center,
            zoom: this.props.zoom,
            maxZoom: this.props.maxZoom,
            minZoom: this.props.minZoom,
            clickableIcons: !!this.props.clickableIcons,
            disableDefaultUI: this.props.disableDefaultUI,
            zoomControl: this.props.zoomControl,
            zoomControlOptions: this.props.zoomControlOptions,
            mapTypeControl: this.props.mapTypeControl,
            mapTypeControlOptions: this.props.mapTypeControlOptions,
            scaleControl: this.props.scaleControl,
            streetViewControl: this.props.streetViewControl,
            streetViewControlOptions: this.props.streetViewControlOptions,
            panControl: this.props.panControl,
            rotateControl: this.props.rotateControl,
            fullscreenControl: this.props.fullscreenControl,
            scrollwheel: this.props.scrollwheel,
            draggable: this.props.draggable,
            draggableCursor: this.props.draggableCursor,
            keyboardShortcuts: this.props.keyboardShortcuts,
            disableDoubleClickZoom: this.props.disableDoubleClickZoom,
            noClear: this.props.noClear,
            styles: this.props.styles,
            gestureHandling: this.props.gestureHandling
          });

          Object.keys(mapConfig).forEach(function (key) {
            // Allow to configure mapConfig with 'false'
            if (mapConfig[key] === null) {
              delete mapConfig[key];
            }
          });

          this.map = new maps.Map(node, mapConfig);

          evtNames.forEach(function (e) {
            _this4.listeners[e] = _this4.map.addListener(e, _this4.handleEvent(e));
          });
          maps.event.trigger(this.map, 'ready');
          this.forceUpdate();
        }
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evtName) {
        var _this5 = this;

        var timeout = void 0;
        var handlerName = 'on' + (0, _String.camelize)(evtName);

        return function (e) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          timeout = setTimeout(function () {
            if (_this5.props[handlerName]) {
              _this5.props[handlerName](_this5.props, _this5.map, e);
            }
          }, 0);
        };
      }
    }, {
      key: 'recenterMap',
      value: function recenterMap() {
        var map = this.map;

        var google = this.props.google;


        if (!google) return;
        var maps = google.maps;

        if (map) {
          var center = this.state.currentLocation;
          if (!(center instanceof google.maps.LatLng)) {
            center = new google.maps.LatLng(center.lat, center.lng);
          }
          // map.panTo(center)
          map.setCenter(center);
          maps.event.trigger(map, 'recenter');
        }
      }
    }, {
      key: 'restyleMap',
      value: function restyleMap() {
        if (this.map) {
          var google = this.props.google;

          google.maps.event.trigger(this.map, 'resize');
        }
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var _this6 = this;

        var children = this.props.children;


        if (!children) return;

        return _react2.default.Children.map(children, function (c) {
          if (!c) return;
          return _react2.default.cloneElement(c, {
            map: _this6.map,
            google: _this6.props.google,
            mapCenter: _this6.state.currentLocation
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var style = Object.assign({}, mapStyles.map, this.props.style, {
          display: this.props.visible ? 'inherit' : 'none'
        });

        var containerStyles = Object.assign({}, mapStyles.container, this.props.containerStyle);

        return _react2.default.createElement(
          'div',
          { style: containerStyles, className: this.props.className },
          _react2.default.createElement(
            'div',
            { style: style, ref: this.mapRef },
            'Loading map...'
          ),
          this.renderChildren()
        );
      }
    }]);

    return Map;
  }(_react2.default.Component);

  Map.propTypes = {
    google: _propTypes2.default.object,
    zoom: _propTypes2.default.number,
    centerAroundCurrentLocation: _propTypes2.default.bool,
    center: _propTypes2.default.object,
    initialCenter: _propTypes2.default.object,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    containerStyle: _propTypes2.default.object,
    visible: _propTypes2.default.bool,
    mapType: _propTypes2.default.string,
    maxZoom: _propTypes2.default.number,
    minZoom: _propTypes2.default.number,
    clickableIcons: _propTypes2.default.bool,
    disableDefaultUI: _propTypes2.default.bool,
    zoomControl: _propTypes2.default.bool,
    zoomControlOptions: _propTypes2.default.object,
    mapTypeControl: _propTypes2.default.bool,
    mapTypeControlOptions: _propTypes2.default.bool,
    scaleControl: _propTypes2.default.bool,
    streetViewControl: _propTypes2.default.bool,
    streetViewControlOptions: _propTypes2.default.object,
    panControl: _propTypes2.default.bool,
    rotateControl: _propTypes2.default.bool,
    fullscreenControl: _propTypes2.default.bool,
    scrollwheel: _propTypes2.default.bool,
    draggable: _propTypes2.default.bool,
    draggableCursor: _propTypes2.default.string,
    keyboardShortcuts: _propTypes2.default.bool,
    disableDoubleClickZoom: _propTypes2.default.bool,
    noClear: _propTypes2.default.bool,
    styles: _propTypes2.default.array,
    gestureHandling: _propTypes2.default.string,
    bounds: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Map.propTypes[(0, _String.camelize)(e)] = _propTypes2.default.func;
  });

  Map.defaultProps = {
    zoom: 14,
    initialCenter: {
      lat: 37.774929,
      lng: -122.419416
    },
    center: {},
    centerAroundCurrentLocation: false,
    style: {},
    containerStyle: {},
    visible: true
  };

  exports.default = Map;
});

/***/ }),

/***/ "+CW9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useStateWithRef; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useStateWithRef() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var initContent = typeof initialState === "function" ? initialState() : initialState;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(initContent),
      state = _useState[0],
      _callback = _useState[1];

  var stateRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(state);
  var callback = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var newContent = typeof newState === "function" ? newState(stateRef.current) : newState;
    stateRef.current = newContent;

    _callback(newContent);
  }, []);
  return [state, stateRef, callback];
}

/***/ }),

/***/ "1lfy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var MobileOnly = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].div.withConfig({
  displayName: "MobileOnly",
  componentId: "sc-7c8xep-0"
})(["display:flex;flex-direction:", ";align-items:", ";", " ", " ", " ", " ", " @media (min-width:900px){display:none;}"], function (props) {
  return props.direction ? props.direction : "column";
}, function (props) {
  return props.align ? props.align : "inherit";
}, function (props) {
  return !!props.position && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["position:", ";"], props.position);
}, function (props) {
  return !!props.bottom && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["bottom:", ";"], props.bottom);
}, function (props) {
  return !!props.right && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["right:", ";"], props.right);
}, function (props) {
  return !!props.width && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["width:", ";"], props.width);
}, function (props) {
  return !!props.height && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["height:", ";"], props.height);
});
/* harmony default export */ __webpack_exports__["a"] = (MobileOnly);

/***/ }),

/***/ "30+C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("17x9");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("iuhU");
/* harmony import */ var _Paper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kKAo");
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("H2TA");







var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
var Card = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["forwardRef"](function Card(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$raised = props.raised,
      raised = _props$raised === void 0 ? false : _props$raised,
      other = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(props, ["classes", "className", "raised"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_Paper__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: Object(clsx__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(classes.root, className),
    elevation: raised ? 8 : 1,
    ref: ref
  }, other));
});
 false ? undefined : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(styles, {
  name: 'MuiCard'
})(Card));

/***/ }),

/***/ "8OQS":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ "Aiso":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("dQHF")


/***/ }),

/***/ "BPiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("Vvt1");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("p46w");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/constants/breakpoints.js
var breakpoints = __webpack_require__("oTwq");

// EXTERNAL MODULE: ./src/context/breakpoints.js
var context_breakpoints = __webpack_require__("/Yzd");

// EXTERNAL MODULE: ./src/hooks/events/useEventListener.js
var useEventListener = __webpack_require__("M6j1");

// EXTERNAL MODULE: ./src/store/modules/popup_manager/actions.js
var actions = __webpack_require__("pOqu");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// CONCATENATED MODULE: ./src/placeholders/Toolbars/Modals/CartMenu.js

var CartMenuPlaceholder = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "CartMenu__CartMenuPlaceholder",
  componentId: "sc-6o5q6g-0"
})(["background-color:white;width:290px;height:400px;border-radius:28px;@media only screen and (min-width:992px){width:411px;}"]);
/* harmony default export */ var CartMenu = (CartMenuPlaceholder);
// EXTERNAL MODULE: ./src/placeholders/Toolbars/Modals/UserMenu.js
var UserMenu = __webpack_require__("StEm");

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("Aiso");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Badge/Badge.js
var Badge = __webpack_require__("IFCi");

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__("PsDL");

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__("5AJ6");

// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/ExpandMore.js


/* harmony default export */ var ExpandMore = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore'));
// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/LocalMall.js


/* harmony default export */ var LocalMall = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
}), 'LocalMall'));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/AccountCircle.js
var AccountCircle = __webpack_require__("ckIp");

// EXTERNAL MODULE: ./src/atomic/common/Buttons/index.js
var Buttons = __webpack_require__("fBnl");

// EXTERNAL MODULE: ./src/atomic/common/Containers/DesktopOnly.js
var DesktopOnly = __webpack_require__("OHIw");

// EXTERNAL MODULE: ./src/atomic/common/Containers/MobileOnly.js
var MobileOnly = __webpack_require__("1lfy");

// EXTERNAL MODULE: ./src/atomic/organisms/MapCard/index.js
var MapCard = __webpack_require__("jmHE");

// EXTERNAL MODULE: ./src/atomic/organisms/PopupManager/index.js
var PopupManager = __webpack_require__("MVkE");

// EXTERNAL MODULE: ./src/atomic/organisms/ProtectRoute/index.js + 1 modules
var ProtectRoute = __webpack_require__("HkjM");

// EXTERNAL MODULE: ./src/atomic/organisms/SearchBar/index.js + 5 modules
var SearchBar = __webpack_require__("KwoO");

// CONCATENATED MODULE: ./src/atomic/organisms/index.js




// EXTERNAL MODULE: ./src/atomic/globals/index.js + 3 modules
var globals = __webpack_require__("BlcV");

// CONCATENATED MODULE: ./src/atomic/pages/Toolbar/styles.js



var Container = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Container",
  componentId: "fut6tp-0"
})(["position:relative;z-index:1000;background-color:#faf8f8;width:100%;box-shadow:0px 10px 34px rgba(0,0,0,0.08);padding:15px 20px;display:flex;flex-direction:column;@media only screen and (min-width:900px){padding:20px 40px;}"]);
var Grid = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Grid",
  componentId: "fut6tp-1"
})(["width:100%;display:grid;grid-template-columns:1fr 1fr;&:not(:last-child){margin-bottom:15px;}& > div{display:flex;align-items:center;}& > div:nth-child(2){justify-content:flex-end;}@media only screen and (min-width:900px){display:grid;grid-template-columns:54% 46%;&:not(:last-child){margin-bottom:0;}}", ""], function (props) {
  return !props.hasButtonLogin && Object(styled_components_browser_esm["a" /* css */])(["@media (max-width:899px){margin-bottom:25px !important;}"]);
});
var Logo = Object(styled_components_browser_esm["b" /* default */])(image_default.a).withConfig({
  displayName: "styles__Logo",
  componentId: "fut6tp-2"
})(["cursor:pointer;width:100px;height:auto;@media only screen and (min-width:900px){width:120px;margin-right:15px;}"]);
var SelectArea = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__SelectArea",
  componentId: "fut6tp-3"
})(["background-color:white;margin-right:15px;border-radius:22px;box-shadow:0 14px 15px 0 rgba(0,0,0,0.03);padding:10px 15px;display:flex;align-items:center;& > img{width:18px;height:18px;}p{margin-left:18px;}"]);
var Address = styled_components_browser_esm["b" /* default */].p.withConfig({
  displayName: "styles__Address",
  componentId: "fut6tp-4"
})(["max-width:150px;margin-right:15px;color:#424242;font-family:", ";font-size:", ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"], globals["b" /* FONTS */].family.roboto_medium, globals["b" /* FONTS */].size.small);
var PopUpMenu = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__PopUpMenu",
  componentId: "fut6tp-5"
})(["position:absolute;z-index:9999;top:", ";", " ", " ", " @media (max-width:425px){right:auto;}"], function (props) {
  return props.top ? props.top : 0;
}, function (props) {
  return !!props.left && props.left && Object(styled_components_browser_esm["a" /* css */])(["left:", ";"], props.left);
}, function (props) {
  return !!props.right && props.right && Object(styled_components_browser_esm["a" /* css */])(["right:", ";"], props.right);
}, function (props) {
  return !!props.align && props.align && Object(styled_components_browser_esm["a" /* css */])(["transform:translate(-100%,0);"]);
});
var CreateStore = styled_components_browser_esm["b" /* default */].span.withConfig({
  displayName: "styles__CreateStore",
  componentId: "fut6tp-6"
})(["color:#878585;font-family:", ";font-size:13px;cursor:pointer;margin-top:4px;position:absolute;bottom:10px;@media (max-width:899px){bottom:0px;top:60px;}"], globals["b" /* FONTS */].family.roboto_medium);
var Column = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Column",
  componentId: "fut6tp-7"
})(["display:flex;flex-direction:column;align-items:center;margin-left:26px;"]);
// CONCATENATED MODULE: ./src/atomic/pages/Toolbar/index.js


var __jsx = react_default.a.createElement;

/* eslint-disable react-hooks/rules-of-hooks */






















var Toolbar_CartMenu = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(13), __webpack_require__.e(140)]).then(__webpack_require__.bind(null, "bnvQ"));
}, {
  loading: function loading() {
    return __jsx(CartMenu, null);
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("bnvQ")];
    },
    modules: ["@@/organisms/Toolbar/CartMenu"]
  }
});
var Toolbar_UserMenu = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "dtfp"));
}, {
  loading: function loading() {
    return __jsx(UserMenu["a" /* default */], null);
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("dtfp")];
    },
    modules: ["@@/organisms/Toolbar/UserMenu"]
  }
});

var Toolbar_Toolbar = function Toolbar() {
  var tokenCookies = js_cookie_default.a.get("token");

  var _useState = Object(react["useState"])(null),
      token = _useState[0],
      setToken = _useState[1];

  Object(react["useEffect"])(function () {
    setToken(tokenCookies);
  }, [tokenCookies]);

  var _useContext = Object(react["useContext"])(context_breakpoints["a" /* default */]),
      currentMatch = _useContext.currentMatch;

  var layoutMiddle = currentMatch[1] < breakpoints["a" /* DEFAULT_BREAKPOINTS */].lg;
  var layoutMobile = currentMatch[1] < breakpoints["a" /* DEFAULT_BREAKPOINTS */].md;
  var anchorRef = Object(react["useRef"])();
  var popUpRef = Object(react["useRef"])();

  var _useState2 = Object(react["useState"])(null),
      popUpType = _useState2[0],
      setPopUpType = _useState2[1];

  var _useState3 = Object(react["useState"])({}),
      popUpPos = _useState3[0],
      setPopUpPos = _useState3[1];

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.root;
  }),
      _coords = _useSelector.coords,
      _cart = _useSelector.cart;

  var dispatch = Object(es["c" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  Object(react["useEffect"])(function () {
    if (!!popUpType && !!anchorRef.current) {
      var pos = {};
      var _anchorRef$current = anchorRef.current,
          offsetTop = _anchorRef$current.offsetTop,
          offsetLeft = _anchorRef$current.offsetLeft,
          offsetWidth = _anchorRef$current.offsetWidth,
          offsetHeight = _anchorRef$current.offsetHeight;
      pos.top = "".concat(offsetTop + offsetHeight, "px");

      if (offsetLeft > window.innerWidth / 2) {
        pos.right = "".concat(window.innerWidth - offsetLeft - offsetWidth, "px");
      } else {
        pos.left = "".concat(offsetLeft, "px");
      }

      setPopUpPos(pos);
    }
  }, [anchorRef, popUpType, layoutMiddle, layoutMobile]);
  var handleClickOutside = Object(react["useCallback"])(function (e) {
    if (anchorRef.current && !anchorRef.current.contains(e.target) && popUpRef.current && !popUpRef.current.contains(e.target)) {
      anchorRef.current = null;
      popUpRef.current = null;
      setPopUpType(null);
    }
  }, [anchorRef, popUpRef]);

  if (true) {
    Object(useEventListener["a" /* default */])("click", handleClickOutside, document);
  }

  var openAddressDialog = function openAddressDialog() {
    dispatch(Object(actions["i" /* setType */])("select-area"));
  };

  var openCart = function openCart(event) {
    if (_cart.length > 0) {
      if (layoutMobile) {
        router.push("/carrinho");
      } else {
        anchorRef.current = event.currentTarget;
        setPopUpType("cart");
      }
    } else {
      router.push("/carrinho");
    }
  };

  var openPopUpMenu = function openPopUpMenu(event, type) {
    anchorRef.current = event.currentTarget;
    setPopUpType(type);
  };

  var renderPopUpMenu = function renderPopUpMenu() {
    switch (popUpType) {
      case "cart":
        return __jsx(PopUpMenu, Object(esm_extends["a" /* default */])({
          ref: popUpRef
        }, popUpPos), __jsx(Toolbar_CartMenu, {
          closeMenu: function closeMenu() {
            return setPopUpType(null);
          }
        }));

      case "user":
        if (layoutMobile) {
          return __jsx(Toolbar_UserMenu, {
            closeMenu: function closeMenu() {
              return setPopUpType(null);
            }
          });
        }

        return __jsx(PopUpMenu, Object(esm_extends["a" /* default */])({
          ref: popUpRef
        }, popUpPos), __jsx(Toolbar_UserMenu, {
          closeMenu: function closeMenu() {
            return setPopUpType(null);
          }
        }));

      default:
        return null;
    }
  };

  return __jsx(Container, null, renderPopUpMenu(), __jsx(Grid, {
    hasButtonLogin: !!token
  }, __jsx("div", null, __jsx("a", {
    style: {
      outline: "none",
      marginRight: 15
    },
    href: "/"
  }, __jsx(Logo, {
    src: "/images/logotipo-dolado-blue.svg",
    alt: "dolado",
    height: "29px",
    width: layoutMiddle ? "100px" : "120px"
  })), __jsx(DesktopOnly["a" /* default */], {
    direction: "row",
    flexGrow: true
  }, __jsx(SearchBar["a" /* default */], {
    search: "all",
    placeholder: "Busque por lojas ou produtos"
  }))), __jsx("div", null, __jsx(DesktopOnly["a" /* default */], {
    direction: "row"
  }, __jsx(SelectArea, null, __jsx(image_default.a, {
    width: layoutMiddle ? "24px" : "18px",
    height: layoutMiddle ? "24px" : "18px",
    src: "/icons/pin.png",
    alt: "pin"
  }), __jsx(Address, null, _coords && _coords.address && _coords.address.length ? _coords.address.split(",")[0] : "Brasil"), __jsx(IconButton["a" /* default */], {
    id: "toolbar-select-address-icon",
    "aria-label": "Navegar por regi\xF5es",
    size: "small",
    onClick: openAddressDialog
  }, __jsx(ExpandMore, null)))), __jsx(MobileOnly["a" /* default */], {
    direction: "row"
  }, __jsx(IconButton["a" /* default */], {
    id: "toolbar-select-address-icon-mobile",
    "aria-label": "Navegar por regi\xF5es",
    size: "small",
    onClick: openAddressDialog,
    style: {
      marginRight: 25
    }
  }, __jsx(image_default.a, {
    width: layoutMiddle ? "24px" : "18px",
    height: layoutMiddle ? "24px" : "18px",
    src: "/icons/pin.png",
    alt: "pin"
  }))), __jsx(IconButton["a" /* default */], {
    id: "toolbar-cart-icon",
    onClick: openCart
  }, __jsx(Badge["a" /* default */], {
    badgeContent: _cart.length,
    color: "primary"
  }, __jsx(LocalMall, null))), token ? __jsx(react_default.a.Fragment, null, __jsx("span", null, "|"), __jsx(IconButton["a" /* default */], {
    id: "toolbar-user-icon",
    onClick: function onClick(e) {
      return openPopUpMenu(e, "user");
    }
  }, __jsx(AccountCircle["a" /* default */], null))) : __jsx(link_default.a, {
    hreflang: "pt-BR",
    href: "/login"
  }, __jsx(Column, null, __jsx(Buttons["b" /* default */], {
    id: "botao-entrar",
    btnWidth: true,
    btnHeight: 44,
    btnDesktopWidth: 100,
    btnBorderRadius: 12,
    bgColor: "#1c6bf7"
  }, __jsx(Buttons["a" /* CustomButtonText */], {
    fontSize: 12,
    fontDesktopSize: 14,
    style: {
      fontFamily: globals["b" /* FONTS */].family.roboto_bold,
      fontWeight: "normal"
    }
  }, "ENTRAR")), __jsx(CreateStore, null, "criar loja gr\xE1tis"))))), __jsx(MobileOnly["a" /* default */], null, __jsx(SearchBar["a" /* default */], {
    search: "all",
    placeholder: "Busque por lojas ou produtos"
  })));
};

/* harmony default export */ var pages_Toolbar = __webpack_exports__["default"] = (Toolbar_Toolbar);

/***/ }),

/***/ "F0eJ":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("q1tI"), __webpack_require__("17x9"), __webpack_require__("qVQj")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Marker = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'dblclick', 'dragend', 'mousedown', 'mouseout', 'mouseover', 'mouseup', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Marker = exports.Marker = function (_React$Component) {
    _inherits(Marker, _React$Component);

    function Marker() {
      _classCallCheck(this, Marker);

      return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
    }

    _createClass(Marker, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.markerPromise = wrappedPromise();
        this.renderMarker();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position || this.props.icon !== prevProps.icon) {
          if (this.marker) {
            this.marker.setMap(null);
          }
          this.renderMarker();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.marker) {
          this.marker.setMap(null);
        }
      }
    }, {
      key: 'renderMarker',
      value: function renderMarker() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            position = _props.position,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            label = _props.label,
            draggable = _props.draggable,
            title = _props.title,
            props = _objectWithoutProperties(_props, ['map', 'google', 'position', 'mapCenter', 'icon', 'label', 'draggable', 'title']);

        if (!google) {
          return null;
        }

        var pos = position || mapCenter;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = new google.maps.LatLng(pos.lat, pos.lng);
        }

        var pref = _extends({
          map: map,
          position: pos,
          icon: icon,
          label: label,
          title: title,
          draggable: draggable
        }, props);
        this.marker = new google.maps.Marker(pref);

        evtNames.forEach(function (e) {
          _this2.marker.addListener(e, _this2.handleEvent(e));
        });

        this.markerPromise.resolve(this.marker);
      }
    }, {
      key: 'getMarker',
      value: function getMarker() {
        return this.markerPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.marker, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Marker;
  }(_react2.default.Component);

  Marker.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Marker.propTypes[e] = _propTypes2.default.func;
  });

  Marker.defaultProps = {
    name: 'Marker'
  };

  exports.default = Marker;
});

/***/ }),

/***/ "F2+K":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("q1tI"), __webpack_require__("17x9"), __webpack_require__("qVQj")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.HeatMap = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseover', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var HeatMap = exports.HeatMap = function (_React$Component) {
    _inherits(HeatMap, _React$Component);

    function HeatMap() {
      _classCallCheck(this, HeatMap);

      return _possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).apply(this, arguments));
    }

    _createClass(HeatMap, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.heatMapPromise = wrappedPromise();
        this.renderHeatMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
          if (this.heatMap) {
            this.heatMap.setMap(null);
            this.renderHeatMap();
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.heatMap) {
          this.heatMap.setMap(null);
        }
      }
    }, {
      key: 'renderHeatMap',
      value: function renderHeatMap() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            positions = _props.positions,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            gradient = _props.gradient,
            _props$radius = _props.radius,
            radius = _props$radius === undefined ? 20 : _props$radius,
            _props$opacity = _props.opacity,
            opacity = _props$opacity === undefined ? 0.2 : _props$opacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'positions', 'mapCenter', 'icon', 'gradient', 'radius', 'opacity']);

        if (!google) {
          return null;
        }

        var data = positions.map(function (pos) {
          return { location: new google.maps.LatLng(pos.lat, pos.lng), weight: pos.weight };
        });

        var pref = _extends({
          map: map,
          gradient: gradient,
          radius: radius,
          opacity: opacity,
          data: data
        }, props);

        this.heatMap = new google.maps.visualization.HeatmapLayer(pref);

        this.heatMap.set('radius', radius === undefined ? 20 : radius);

        this.heatMap.set('opacity', opacity === undefined ? 0.2 : opacity);

        evtNames.forEach(function (e) {
          _this2.heatMap.addListener(e, _this2.handleEvent(e));
        });

        this.heatMapPromise.resolve(this.heatMap);
      }
    }, {
      key: 'getHeatMap',
      value: function getHeatMap() {
        return this.heatMapPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.heatMap, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return HeatMap;
  }(_react2.default.Component);

  HeatMap.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object,
    icon: _propTypes2.default.string
  };

  evtNames.forEach(function (e) {
    return HeatMap.propTypes[e] = _propTypes2.default.func;
  });

  HeatMap.defaultProps = {
    name: 'HeatMap'
  };

  exports.default = HeatMap;
});

/***/ }),

/***/ "IFCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("17x9");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("iuhU");
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("H2TA");
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("NqtD");







var RADIUS_STANDARD = 10;
var RADIUS_DOT = 4;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      flexShrink: 0
    },

    /* Styles applied to the badge `span` element. */
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      boxSizing: 'border-box',
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      minWidth: RADIUS_STANDARD * 2,
      lineHeight: 1,
      padding: '0 6px',
      height: RADIUS_STANDARD * 2,
      borderRadius: RADIUS_STANDARD,
      zIndex: 1,
      // Render the badge on top of potential ripples.
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },

    /* Styles applied to the root element if `variant="dot"`. */
    dot: {
      borderRadius: RADIUS_DOT,
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
    anchorOriginTopRightRectangle: {
      top: 0,
      right: 0,
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
    anchorOriginBottomRightRectangle: {
      bottom: 0,
      right: 0,
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
    anchorOriginTopLeftRectangle: {
      top: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
    anchorOriginBottomLeftRectangle: {
      bottom: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
    anchorOriginTopRightCircle: {
      top: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
    anchorOriginBottomRightCircle: {
      bottom: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
    anchorOriginTopLeftCircle: {
      top: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
    anchorOriginBottomLeftCircle: {
      bottom: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
    invisible: {
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  };
};
var Badge = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["forwardRef"](function Badge(props, ref) {
  var _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'right'
  } : _props$anchorOrigin,
      badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
      invisibleProp = props.invisible,
      _props$max = props.max,
      max = _props$max === void 0 ? 99 : _props$max,
      _props$overlap = props.overlap,
      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
      _props$showZero = props.showZero,
      showZero = _props$showZero === void 0 ? false : _props$showZero,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);

  var invisible = invisibleProp;

  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
    invisible = true;
  }

  var displayValue = '';

  if (variant !== 'dot') {
    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["createElement"](ComponentProp, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: Object(clsx__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(classes.root, className),
    ref: ref
  }, other), children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("span", {
    className: Object(clsx__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(classes.badge, classes["".concat(anchorOrigin.horizontal).concat(Object(_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat(Object(_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(anchorOrigin.vertical)).concat(Object(_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(anchorOrigin.horizontal)).concat(Object(_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(overlap))], color !== 'default' && classes["color".concat(Object(_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
  }, displayValue));
});
 false ? undefined : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(styles, {
  name: 'MuiBadge'
})(Badge));

/***/ }),

/***/ "KwoO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./src/helpers/index.js + 24 modules
var helpers = __webpack_require__("zpb6");

// EXTERNAL MODULE: ./src/hooks/state-management/useStateWithRef.js
var useStateWithRef = __webpack_require__("+CW9");

// EXTERNAL MODULE: ./src/store/modules/popup_manager/actions.js
var actions = __webpack_require__("pOqu");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./src/requests/stores.js
var requests_stores = __webpack_require__("JC4P");

// EXTERNAL MODULE: ./src/config/api.js
var api = __webpack_require__("o75L");

// EXTERNAL MODULE: ./src/errors/index.js
var errors = __webpack_require__("y4VH");

// CONCATENATED MODULE: ./src/requests/search.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function searchProducts(_x) {
  return _searchProducts.apply(this, arguments);
}

function _searchProducts() {
  _searchProducts = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(search) {
    var _ref,
        latitude,
        longitude,
        storeId,
        _response$data,
        body,
        response,
        products,
        bucketUrl,
        _args = arguments;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, latitude = _ref.latitude, longitude = _ref.longitude, storeId = _ref.storeId;
            _context.prev = 1;
            body = {};

            if (latitude && longitude) {
              body.latitude = latitude;
              body.longitude = longitude;
            }

            if (storeId) {
              body.company_id = storeId;
            }

            _context.next = 7;
            return api["a" /* default */].post("/v1/search/products/".concat(encodeURI(search)), body);

          case 7:
            response = _context.sent;
            products = [];
            bucketUrl = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.bucket_url;

            if (response.status === 200) {
              products = response.data.products.map(function (prd) {
                var temp = _objectSpread({}, prd);

                temp.photos = temp.photos.map(function (pht) {
                  return bucketUrl + pht;
                });
                return temp;
              });
            }

            return _context.abrupt("return", {
              status: response.status,
              products: products
            });

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            throw new errors["d" /* SearchException */](_context.t0);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 14]]);
  }));
  return _searchProducts.apply(this, arguments);
}

function searchStores(_x2) {
  return _searchStores.apply(this, arguments);
}

function _searchStores() {
  _searchStores = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(search) {
    var _ref2,
        latitude,
        longitude,
        body,
        response,
        companies,
        _args2 = arguments;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref2 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, latitude = _ref2.latitude, longitude = _ref2.longitude;
            _context2.prev = 1;
            body = latitude && longitude ? JSON.stringify({
              latitude: latitude,
              longitude: longitude
            }) : null;
            _context2.next = 5;
            return api["a" /* default */].post("/v1/search/companies/".concat(encodeURI(search)), body);

          case 5:
            response = _context2.sent;
            companies = [];
            if (response.status === 200) companies = Object(helpers["m" /* parseStoresImages */])(response.data);
            return _context2.abrupt("return", {
              status: response.status,
              companies: companies
            });

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            throw new errors["a" /* CompaniesException */](_context2.t0);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 11]]);
  }));
  return _searchStores.apply(this, arguments);
}
// CONCATENATED MODULE: ./src/hooks/tools/useInterval.js

function useInterval(callback, delay) {
  var savedCallback = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    savedCallback.current = callback;
  }, [callback]);
  Object(react["useEffect"])(function () {
    function tick() {
      savedCallback.current();
    }

    var id = null;

    if (delay !== null) {
      id = setInterval(tick, delay);
    }

    return function () {
      if (id !== null) clearInterval(id);
    };
  }, [delay]);
}
// EXTERNAL MODULE: ./node_modules/react-loading/dist/react-loading.js
var react_loading = __webpack_require__("Ko7v");
var react_loading_default = /*#__PURE__*/__webpack_require__.n(react_loading);

// EXTERNAL MODULE: ./src/atomic/atoms/ImageFrame/index.js + 1 modules
var ImageFrame = __webpack_require__("l6Rm");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./src/atomic/globals/index.js + 3 modules
var globals = __webpack_require__("BlcV");

// CONCATENATED MODULE: ./src/atomic/molecules/Search/styles.js


var Container = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-12ndnnx-0"
})(["font-family:", ";font-size:", ";position:absolute;background-color:white;color:black;width:100%;left:0px;top:20px;text-align:left;padding:13px;z-index:9999;margin-top:20px;box-shadow:0px 15px 20px 0px rgba(0,0,0,0.1);border-bottom-left-radius 32px;border-bottom-right-radius 32px;@media only screen and (min-width:600px){top:34px;}@media only screen and (min-width:600px) and (max-width:875px){top:22px;}"], globals["b" /* FONTS */].family.roboto_regular, globals["b" /* FONTS */].size.base);
var Loading = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Loading",
  componentId: "sc-12ndnnx-1"
})(["width:100%;height:100%;display:flex;flex-wrap:wrap;flex-direction:row;justify-content:center;"]);
var DropdownStyled = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__DropdownStyled",
  componentId: "sc-12ndnnx-2"
})(["padding:10px 0px;p{text-align:center;}"]);
var DropdownItem = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__DropdownItem",
  componentId: "sc-12ndnnx-3"
})(["display:flex;flex-wrap:nowrap;justify-content:", ";align-items:center;cursor:pointer;height:40px;padding:3px 0px;margin-bottom:10px;:hover{box-shadow:0px 4px 20px 0px rgba(0,0,0,0.1);}"], function (props) {
  return props.justifyContent ? props.justifyContent : "space-between";
});
var Name = styled_components_browser_esm["b" /* default */].span.withConfig({
  displayName: "styles__Name",
  componentId: "sc-12ndnnx-4"
})(["font-family:", ";font-size:", ";width:30%;overflow:hidden;max-height:100%;"], globals["b" /* FONTS */].family.roboto_regular, globals["b" /* FONTS */].size.base);
var StoreName = styled_components_browser_esm["b" /* default */].span.withConfig({
  displayName: "styles__StoreName",
  componentId: "sc-12ndnnx-5"
})(["font-family:", ";font-size:", ";margin-left:30px;width:max-content;overflow:hidden;max-height:100%;"], globals["b" /* FONTS */].family.roboto_regular, globals["b" /* FONTS */].size.base);
var Description = styled_components_browser_esm["b" /* default */].span.withConfig({
  displayName: "styles__Description",
  componentId: "sc-12ndnnx-6"
})(["font-family:", ";font-size:", ";color:rgba(70,70,70,0.65);width:20%;@media (max-width:900px){display:none;}"], globals["b" /* FONTS */].family.roboto_regular, globals["b" /* FONTS */].size.base);
var Button = styled_components_browser_esm["b" /* default */].button.withConfig({
  displayName: "styles__Button",
  componentId: "sc-12ndnnx-7"
})(["font-family:", ";font-size:", ";border-style:none;background-color:transparent;cursor:pointer;margin-left:10px;:focus{border-style:none;background-color:transparent;}"], globals["b" /* FONTS */].family.roboto_regular, globals["b" /* FONTS */].size.base);
var ButtonContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__ButtonContainer",
  componentId: "sc-12ndnnx-8"
})(["width:100%;margin-top:10px;display:flex;flex-wrap:nowrap;justify-content:center;align-items:center;"]);
var Spacer = styled_components_browser_esm["b" /* default */].span.withConfig({
  displayName: "styles__Spacer",
  componentId: "sc-12ndnnx-9"
})(["width:10px;"]);
var ImageContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__ImageContainer",
  componentId: "sc-12ndnnx-10"
})(["width:36px;height:36px;margin-right:10px;align-self:center;"]);
var StoreImageContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__StoreImageContainer",
  componentId: "sc-12ndnnx-11"
})(["font-family:", ";font-weight:900;font-size:14px;color:#9cafd9;width:36px;height:36px;border-radius:10px;margin-right:10px;background-color:#f5f8ff;justify-content:center;display:flex;overflow:hidden;align-items:center;"], globals["b" /* FONTS */].family.roboto_regular);
// CONCATENATED MODULE: ./src/atomic/molecules/Search/index.js






var __jsx = react_default.a.createElement;

function Search_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Search_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Search_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Search_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var getInitials = function getInitials(name) {
  var splitted = name.split(" ");

  if (splitted.length > 2) {
    splitted = [splitted[0], splitted[splitted.length - 1]];
  }

  return splitted.map(function (word) {
    return word[0];
  });
};

var productPlaceholder = "https://darez-app-imgs.s3.amazonaws.com/estatico/imagens/placeholder.png";

var Search_Search = function Search(_ref) {
  var digits = _ref.digits,
      company_id = _ref.company_id,
      search = _ref.search,
      propagateEvent = _ref.propagateEvent;

  var _useState = Object(react["useState"])([]),
      stores = _useState[0],
      setStores = _useState[1];

  var _useState2 = Object(react["useState"])([]),
      products = _useState2[0],
      setProducts = _useState2[1];

  var _useState3 = Object(react["useState"])(true),
      requestChanges = _useState3[0],
      setRequestChanges = _useState3[1];

  var _useState4 = Object(react["useState"])(""),
      prevDigits = _useState4[0],
      setPrevDigits = _useState4[1];

  var _useState5 = Object(react["useState"])(true),
      loading = _useState5[0],
      setLoading = _useState5[1];

  var _coords = Object(es["d" /* useSelector */])(function (state) {
    return state.root.coords;
  });

  var dispatch = Object(es["c" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  useInterval(function () {
    if (!requestChanges) setRequestChanges(true);
  }, 1500);
  var getResults = Object(react["useCallback"])( /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
    var _yield$searchProducts, _products, _yield$searchStores, companies, _yield$searchProducts2, _products2;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(search === "all")) {
              _context.next = 10;
              break;
            }

            _context.next = 3;
            return searchProducts(digits, Search_objectSpread({}, _coords));

          case 3:
            _yield$searchProducts = _context.sent;
            _products = _yield$searchProducts.products;
            _context.next = 7;
            return searchStores(digits, Search_objectSpread({}, _coords));

          case 7:
            _yield$searchStores = _context.sent;
            companies = _yield$searchStores.companies;
            return _context.abrupt("return", {
              products: _products,
              stores: companies
            });

          case 10:
            if (!(search === "produtos")) {
              _context.next = 16;
              break;
            }

            _context.next = 13;
            return searchProducts(digits, company_id ? {
              storeId: company_id
            } : Search_objectSpread({}, _coords));

          case 13:
            _yield$searchProducts2 = _context.sent;
            _products2 = _yield$searchProducts2.products;
            return _context.abrupt("return", {
              products: _products2,
              stores: []
            });

          case 16:
            return _context.abrupt("return", {
              products: [],
              stores: []
            });

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [_coords, company_id, digits, search]);
  Object(react["useEffect"])(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  setPrevDigits(digits);
                  setRequestChanges(false);
                  setTimeout( /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                    var _yield$getResults, _products, _stores;

                    return regenerator_default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return getResults();

                          case 2:
                            _yield$getResults = _context2.sent;
                            _products = _yield$getResults.products;
                            _stores = _yield$getResults.stores;
                            setProducts(_products || []);
                            setStores(_stores || []);
                            setLoading(false);

                          case 8:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })), 400);
                } catch (error) {
                  dispatch(Object(actions["g" /* createPopup */])("alert", "Não foi possível fazer a busca", {
                    type: "error"
                  }));
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _fetchData.apply(this, arguments);
    }

    if (!requestChanges) setLoading(true);else if (digits && digits !== "" && digits !== prevDigits && _coords.latitude && _coords.longitude) fetchData();
  }, [digits, company_id, requestChanges, prevDigits, _coords, search, dispatch, getResults]);

  var fixNome = function fixNome(nome) {
    if (nome !== undefined && nome !== null) {
      if (nome.length > 15) {
        nome = nome.slice(0, 15).concat("...");
        return nome;
      }

      return nome;
    }

    return nome;
  };

  var onClickProduto = /*#__PURE__*/function () {
    var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee4(item) {
      var _yield$fetchPublicSto, status, data;

      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Object(requests_stores["b" /* fetchPublicStoreData */])(item.company_id);

            case 2:
              _yield$fetchPublicSto = _context4.sent;
              status = _yield$fetchPublicSto.status;
              data = Object(objectWithoutProperties["a" /* default */])(_yield$fetchPublicSto, ["status"]);

              if (status === 200) {
                router.push("/[content]/produto/[...sub_content]", "/".concat(data.endpoint, "/produto/").concat(item.name.toLowerCase().normalize("NFKD").replace(/[^\w]/g, ""), "/").concat(Object(helpers["e" /* encryptBase64 */])(item.objectID)));
                propagateEvent();
              }

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onClickProduto(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var goToSearchPage = function goToSearchPage() {
    router.push({
      pathname: "/busca",
      query: {
        search: digits
      }
    });
    propagateEvent();
  };

  var onClickEmpresa = function onClickEmpresa(store) {
    if (store.endpoint) {
      router.push("/[content]", "/".concat(store.endpoint));
      propagateEvent();
    } else {
      dispatch(Object(actions["g" /* createPopup */])("alert", "Não foi possível carregar a url da loja", {
        type: "error"
      }));
    }
  };

  var handleProductImage = function handleProductImage(photos) {
    if (photos && photos.length > 0) {
      return photos[0];
    }

    return productPlaceholder;
  };

  if (loading) {
    return __jsx(Container, null, __jsx(Loading, null, __jsx(react_loading_default.a, {
      type: "bubbles",
      color: "black",
      height: "auto",
      width: "10%"
    })));
  }

  return (_coords === null || _coords === void 0 ? void 0 : _coords.latitude) && (_coords === null || _coords === void 0 ? void 0 : _coords.longitude) && __jsx(Container, null, (products === null || products === void 0 ? void 0 : products.length) > 0 && __jsx(DropdownStyled, null, __jsx("p", null, __jsx("b", null, "Produtos")), products === null || products === void 0 ? void 0 : products.slice(0, 7).map(function (item, idx) {
    return __jsx(DropdownItem, Object(esm_extends["a" /* default */])({
      key: idx,
      onClick: function onClick() {
        return onClickProduto(item);
      }
    }, idx === 0 ? {
      id: "product-first-option"
    } : {}), __jsx(ImageContainer, null, __jsx(ImageFrame["a" /* default */], {
      src: handleProductImage(item.photos),
      alt: ""
    })), __jsx(Name, null, " ", fixNome(item.name)), __jsx(Spacer, null), __jsx(Description, null, fixNome(item.description)), __jsx(Spacer, null), __jsx("span", null, "R$", " ", parseInt(item.price).toFixed(2).toString().replace(".", ",")));
  })), (stores === null || stores === void 0 ? void 0 : stores.length) > 0 && __jsx(DropdownStyled, null, __jsx("p", null, __jsx("b", null, "Empresas")), stores === null || stores === void 0 ? void 0 : stores.slice(0, 7).map(function (item, idx) {
    return __jsx(DropdownItem, Object(esm_extends["a" /* default */])({
      justifyContent: "stretch",
      key: idx,
      onClick: function onClick() {
        return onClickEmpresa(item);
      }
    }, idx === 0 ? {
      id: "store-first-option"
    } : {}), item.logo ? __jsx(ImageContainer, null, __jsx(ImageFrame["a" /* default */], {
      src: item.logo,
      alt: ""
    })) : __jsx(StoreImageContainer, null, getInitials(item.fantasy_name)), __jsx(StoreName, null, fixNome(item.fantasy_name)));
  })), __jsx(ButtonContainer, null, stores.length || products.length ? "".concat(stores.length + products.length, " resultados.") : null, __jsx(Button, {
    onClick: function onClick() {
      return goToSearchPage();
    }
  }, __jsx("u", null, "Ver todos"))));
};

Search_Search.defaultProps = {
  digits: "",
  company_id: 0,
  search: "",
  propagateEvent: function propagateEvent() {}
};
/* harmony default export */ var molecules_Search = (Search_Search);
// CONCATENATED MODULE: ./src/atomic/organisms/SearchBar/styles.js


var styles_Container = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-7wdvzy-0"
})(["font-family:", ";font-size:", ";position:relative;display:flex;flex-wrap:nowrap;justify-content:space-between;width:90%;height:64px;border-radius:14px;box-shadow:0px 7.37px 36.0468px rgba(0,0,0,0.05);background-color:#ffffff;@media only screen and (max-width:870px){width:100%;height:50px;border-radius:14px;box-shadow:0px 7.37px 36.0468px rgba(0,0,0,0.05);background-color:#ffffff;}"], globals["b" /* FONTS */].family.roboto_regular, globals["b" /* FONTS */].size.base);
var SearchInput = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__SearchInput",
  componentId: "sc-7wdvzy-1"
})(["z-index:9;margin:auto;font-family:", ";font-size:", ";color:#aeaeae;width:90%;border:none;outline:none;input{font-family:", ";font-size:", ";width:100%;height:100%;border:none;outline:none!important;outline-offset:0px!important;}input:focus{outline:none!important;outline-offset:0px!important;}@media only screen and (max-width:870px){margin:auto;font-family:Roboto Medium;font-size:14px;font-weight:500;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;color:#aeaeae;border:none;outline:none;}"], globals["b" /* FONTS */].family.roboto_regular, globals["b" /* FONTS */].size.base, globals["b" /* FONTS */].family.roboto_regular, globals["b" /* FONTS */].size.base);
var SearchIcon = styled_components_browser_esm["b" /* default */].img.withConfig({
  displayName: "styles__SearchIcon",
  componentId: "sc-7wdvzy-2"
})(["left:15px;align-items:center;justify-content:left;margin-top:auto;margin-bottom:auto;margin-left:10px;margin-right:10px;width:auto;height:26px;z-index:10;"]);
// CONCATENATED MODULE: ./src/atomic/organisms/SearchBar/index.js


var SearchBar_jsx = react_default.a.createElement;








var SearchBar_SearchBar = function SearchBar(_ref) {
  var customId = _ref.customId,
      placeholder = _ref.placeholder,
      company_id = _ref.company_id,
      search = _ref.search,
      callback = _ref.callback,
      onKeyUp = _ref.onKeyUp,
      hideDropdown = _ref.hideDropdown,
      digitsParent = _ref.digitsParent,
      customIcon = _ref.customIcon;

  var _useStateWithRef = Object(useStateWithRef["a" /* default */])(digitsParent || ""),
      _useStateWithRef2 = Object(slicedToArray["a" /* default */])(_useStateWithRef, 3),
      digits = _useStateWithRef2[0],
      digitsRef = _useStateWithRef2[1],
      setDigits = _useStateWithRef2[2];

  var _useState = Object(react["useState"])(true),
      showOptions = _useState[0],
      setShowOptions = _useState[1];

  var ref = Object(react["useRef"])();

  var _coords = Object(es["d" /* useSelector */])(function (state) {
    return state.root.coords;
  });

  var dispatch = Object(es["c" /* useDispatch */])();

  var onChange = function onChange(e) {
    if (e.target.value.length <= 100) {
      setDigits(e.target.value);
      setShowOptions(true);
      if (callback) callback(e.target.value);
    }
  };

  var onFocus = function onFocus(event) {
    if (!(_coords === null || _coords === void 0 ? void 0 : _coords.latitude) || !(_coords === null || _coords === void 0 ? void 0 : _coords.longitude)) {
      event.target.blur();
      dispatch(Object(actions["g" /* createPopup */])("select-area"));
    }
  };

  var onRouteChange = function onRouteChange() {
    setDigits("");
    setShowOptions(false);
  };

  var useOutsideClick = function useOutsideClick(refProp, callbackProp) {
    var handleClick = function handleClick(e) {
      if (refProp.current && !refProp.current.contains(e.target)) {
        callbackProp();
      }
    };

    Object(react["useEffect"])(function () {
      document.addEventListener("click", handleClick);
      return function () {
        document.removeEventListener("click", handleClick);
      };
    });
  };

  useOutsideClick(ref, function () {
    setShowOptions(false);
  });
  Object(react["useEffect"])(function () {
    if (typeof digitsParent !== "undefined" && digitsRef.current !== digitsParent) setDigits(digitsParent);
  }, [digitsParent, digitsRef, setDigits]);
  /**
   * Performing data collection, and send to data analystic server
   *
   * @param {string} value String that will be search
   */

  var handleAnalytics = function handleAnalytics(value) {
    try {
      Object(helpers["f" /* fetchAnalytics */])("search", {
        event_type: "SEARCH/LOC",
        query: value,
        lat: _coords.latitude,
        lng: _coords.longitude
      });
    } catch (err) {
      console.log(err);
    }
  };
  /**
   * Process key down
   *
   * @param {object} e Input object
   */


  var handleKeyUp = function handleKeyUp(e) {
    // skip this keys..
    var keyList = ["Shift", "CapsLock", "Control", "Backspace", "Delete"];
    var value = e.target.value;

    if (keyList.indexOf(e.key) < 0) {
      handleAnalytics(value);
    }
  };

  return SearchBar_jsx(styles_Container, {
    ref: ref
  }, SearchBar_jsx(SearchIcon, {
    src: customIcon || "/icons/search.svg",
    alt: "Imagem Indisponivel"
  }), SearchBar_jsx(SearchInput, null, SearchBar_jsx("input", {
    autoComplete: "off",
    className: "search-bar-input",
    type: "text",
    value: digits,
    placeholder: placeholder,
    onChange: onChange,
    onKeyUp: onKeyUp || handleKeyUp,
    onFocus: onFocus,
    id: customId || "search-bar-input"
  }), !hideDropdown && digits.length > 0 && showOptions && SearchBar_jsx(molecules_Search, {
    company_id: company_id || null,
    digits: digits,
    search: search,
    propagateEvent: onRouteChange
  })));
};

SearchBar_SearchBar.defaultProps = {
  customId: "",
  hideDropdown: false,
  callback: function callback() {},
  customIcon: null
};
/* harmony default export */ var organisms_SearchBar = __webpack_exports__["a"] = (SearchBar_SearchBar);

/***/ }),

/***/ "M6j1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useEventListener; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useEventListener(eventName, handler, element) {
  var savedHandler = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])();
  var saveElement = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])();
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    savedHandler.current = handler;
  }, [handler]);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    saveElement.current = element;
  }, [element]);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (typeof saveElement.current === "undefined") saveElement.current = window;
    var isSupported = saveElement.current && saveElement.current.addEventListener;
    if (!isSupported) return;

    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };

    saveElement.current.addEventListener(eventName, eventListener); // eslint-disable-next-line consistent-return

    return function () {
      saveElement.current.removeEventListener(eventName, eventListener);
    };
  }, [eventName]);
}

/***/ }),

/***/ "MVkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("/MKj");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Vvt1");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("pOqu");

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var AddPromotion = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(11), __webpack_require__.e(12), __webpack_require__.e(80)]).then(__webpack_require__.bind(null, "K0Ef"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("K0Ef")];
    },
    modules: ["@@/molecules/AddPromotion"]
  }
});
var Alert = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(107)]).then(__webpack_require__.bind(null, "4Wd8"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("4Wd8")];
    },
    modules: ["@@/molecules/Alert"]
  }
});
var LocationOff = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(16), __webpack_require__.e(120)]).then(__webpack_require__.bind(null, "pYuZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("pYuZ")];
    },
    modules: ["@@/molecules/LocationOff"]
  }
});
var SelectArea = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(16), __webpack_require__.e(110)]).then(__webpack_require__.bind(null, "TYYV"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("TYYV")];
    },
    modules: ["@@/molecules/SelectArea"]
  }
});
var SignUpStoreSuccess = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(16), __webpack_require__.e(118)]).then(__webpack_require__.bind(null, "USb1"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("USb1")];
    },
    modules: ["@@/molecules/SignUpStoreSuccess"]
  }
});
var SignUpSuccess = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(16), __webpack_require__.e(119)]).then(__webpack_require__.bind(null, "52b3"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("52b3")];
    },
    modules: ["@@/molecules/SignUpSuccess"]
  }
});

var PopupManager = function PopupManager() {
  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "d"])(function (state) {
    return state.popup_manager;
  }),
      _type = _useSelector.type,
      _message = _useSelector.message,
      _data = _useSelector.data;

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useDispatch */ "c"])();

  var closePopup = function closePopup() {
    dispatch(Object(_store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_3__[/* setType */ "i"])(null));
  };

  var goBackSelectArea = function goBackSelectArea() {
    dispatch(Object(_store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_3__[/* setType */ "i"])("select-area"));
  };

  var resetAlert = function resetAlert() {
    dispatch(Object(_store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_3__[/* resetPopup */ "h"])());
  };

  switch (_type) {
    case "alert":
      return __jsx(Alert, {
        type: _data.type,
        imageSrc: _data.photo,
        errorMessage: _message,
        callback: resetAlert,
        duration: _data.duration
      });

    case "add-promotion":
      return __jsx(AddPromotion, {
        initProducts: _data.products,
        callback: closePopup
      });

    case "location-off":
      return __jsx(LocationOff, {
        goBackCB: goBackSelectArea,
        closeCB: closePopup
      });

    case "select-area":
      return __jsx(SelectArea, {
        callback: closePopup
      });

    case "sign-up":
      return __jsx(SignUpSuccess, {
        name: _message,
        closeCB: closePopup
      });

    case "sign-up-store":
      return __jsx(SignUpStoreSuccess, {
        name: _message,
        closeCB: closePopup
      });

    default:
      return null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (PopupManager);

/***/ }),

/***/ "NYLY":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("q1tI"), __webpack_require__("17x9"), __webpack_require__("kq0K"), __webpack_require__("qVQj")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes, _areBoundsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Rectangle = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Rectangle = exports.Rectangle = function (_React$Component) {
    _inherits(Rectangle, _React$Component);

    function Rectangle() {
      _classCallCheck(this, Rectangle);

      return _possibleConstructorReturn(this, (Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).apply(this, arguments));
    }

    _createClass(Rectangle, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.rectanglePromise = wrappedPromise();
        this.renderRectangle();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _areBoundsEqual.areBoundsEqual)(this.props.bounds, prevProps.bounds)) {
          if (this.rectangle) {
            this.rectangle.setMap(null);
          }
          this.renderRectangle();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.rectangle) {
          this.rectangle.setMap(null);
        }
      }
    }, {
      key: 'renderRectangle',
      value: function renderRectangle() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            bounds = _props.bounds,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            fillColor = _props.fillColor,
            fillOpacity = _props.fillOpacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'bounds', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          bounds: bounds,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight,
          fillColor: fillColor,
          fillOpacity: fillOpacity
        }, props);

        this.rectangle = new google.maps.Rectangle(params);

        evtNames.forEach(function (e) {
          _this2.rectangle.addListener(e, _this2.handleEvent(e));
        });

        this.rectanglePromise.resolve(this.rectangle);
      }
    }, {
      key: 'getRectangle',
      value: function getRectangle() {
        return this.rectanglePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.rectangle, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        console.log('hii, ', this.props.bounds);
        return null;
      }
    }]);

    return Rectangle;
  }(_react2.default.Component);

  Rectangle.propTypes = {
    bounds: _propTypes2.default.object,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Rectangle.propTypes[e] = _propTypes2.default.func;
  });

  Rectangle.defaultProps = {
    name: 'Rectangle'
  };

  exports.default = Rectangle;
});

/***/ }),

/***/ "OHIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var DesktopOnly = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].div.withConfig({
  displayName: "DesktopOnly",
  componentId: "sc-1onnrlv-0"
})(["display:none;> *{margin:", ";}@media (min-width:900px){", " display:flex;flex-direction:", ";align-items:", ";", ";", ";", ";}"], function (props) {
  return props.childrenMargin ? props.childrenMargin : "0px";
}, function (props) {
  return !!props.flexGrow && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["flex-grow:1;"]);
}, function (props) {
  return props.direction ? props.direction : "column";
}, function (props) {
  return props.align ? props.align : "inherit";
}, function (props) {
  return props.justify && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["justify-content:space-between;"]);
}, function (props) {
  return props.spaceBottom && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["margin-bottom:30px;"]);
}, function (props) {
  return props.spaceTop && Object(styled_components__WEBPACK_IMPORTED_MODULE_0__[/* css */ "a"])(["margin-top:30px;"]);
});
/* harmony default export */ __webpack_exports__["a"] = (DesktopOnly);

/***/ }),

/***/ "PcuG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vOnD");
/* harmony import */ var _material_ui_core_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("30+C");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var CustomCard = Object(styled_components__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])(_material_ui_core_Card__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]).withConfig({
  displayName: "DefaultCard__CustomCard",
  componentId: "cfl7w6-0"
})(["&&{background-color:#ffffff;box-shadow:", ";display:flex;flex-direction:column;justify-content:flex-start;width:", ";", " margin:", ";border-radius:", ";padding:", ";position:relative;}"], function (props) {
  return props.shadow ? "0 4px 10px 0 rgba(0,0,0,0.04)" : "none";
}, function (props) {
  return props.width ? props.width : "max-content";
}, function (props) {
  return props.height ? "height: ".concat(props.height, ";") : "";
}, function (props) {
  return props.margin ? props.margin : "0";
}, function (props) {
  return props.radius ? props.radius : "42px";
}, function (props) {
  return props.padding ? props.padding : "0";
});

var DefaultCard = function DefaultCard(_ref) {
  var children = _ref.children,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children"]);

  return __jsx(CustomCard, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    "data-testid": "default-card-component"
  }), children);
};

DefaultCard.defaultProps = {
  children: "Card"
};
/* harmony default export */ __webpack_exports__["a"] = (DefaultCard);

/***/ }),

/***/ "PsDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("17x9");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("iuhU");
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("H2TA");
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ye/S");
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("VD++");
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("NqtD");










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: Object(_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_6__[/* fade */ "c"])(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_6__[/* fade */ "c"])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_6__[/* fade */ "c"])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["forwardRef"](function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_ButtonBase__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: Object(clsx__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(classes.root, className, color !== 'default' && classes["color".concat(Object(_utils_capitalize__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(color))], disabled && classes.disabled, size === "small" && classes["size".concat(Object(_utils_capitalize__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("span", {
    className: classes.label
  }, children));
});
 false ? undefined : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),

/***/ "StEm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var UserMenuPlaceholder = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].div.withConfig({
  displayName: "UserMenu__UserMenuPlaceholder",
  componentId: "sc-1qu23iv-0"
})(["background-color:rgba(0,0,0,0.2);position:absolute;overflow-y:auto;z-index:9999;left:0;top:0;width:100%;height:100vh;@media only screen and (min-width:768px){position:relative;background-color:white;width:260px;height:400px;border-radius:28px;}@media only screen and (min-width:992px){width:350px;}"]);
/* harmony default export */ __webpack_exports__["a"] = (UserMenuPlaceholder);

/***/ }),

/***/ "UWYU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
exports.__esModule=true;exports.imageConfigDefault=exports.VALID_LOADERS=void 0;const VALID_LOADERS=['default','imgix','cloudinary','akamai'];exports.VALID_LOADERS=VALID_LOADERS;const imageConfigDefault={deviceSizes:[640,750,828,1080,1200,1920,2048,3840],imageSizes:[16,32,48,64,96,128,256,384],path:'/_next/image',loader:'default',domains:[]};exports.imageConfigDefault=imageConfigDefault;
//# sourceMappingURL=image-config.js.map

/***/ }),

/***/ "WVtz":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html

  var makeCancelable = exports.makeCancelable = function makeCancelable(promise) {
    var hasCanceled_ = false;

    var wrappedPromise = new Promise(function (resolve, reject) {
      promise.then(function (val) {
        return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
      });
      promise.catch(function (error) {
        return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
      });
    });

    return {
      promise: wrappedPromise,
      cancel: function cancel() {
        hasCanceled_ = true;
      }
    };
  };
});

/***/ }),

/***/ "YFqc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cTJO")


/***/ }),

/***/ "ZZ2F":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  /**
   * Compares two path arrays of LatLng objects.
   */

  var arePathsEqual = exports.arePathsEqual = function arePathsEqual(pathA, pathB) {
    if (pathA === pathB) {
      return true;
    }
    if (!Array.isArray(pathA) || !Array.isArray(pathB)) {
      return false;
    }
    if (pathA.length !== pathB.length) {
      return false;
    }
    for (var i = 0; i < pathA.length; ++i) {
      if (pathA[i] === pathB[i]) {
        continue;
      }
      if (!isValidLatLng(pathA[i]) || !isValidLatLng(pathB[i])) {
        return false;
      }
      if (pathB[i].lat !== pathA[i].lat || pathB[i].lng !== pathA[i].lng) {
        return false;
      }
    }
    return true;
  };

  /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */
  var isValidLatLng = function isValidLatLng(elem) {
    return elem !== null && (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object' && elem.hasOwnProperty('lat') && elem.hasOwnProperty('lng');
  };
});

/***/ }),

/***/ "aabA":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("q1tI"), __webpack_require__("17x9"), __webpack_require__("ZZ2F"), __webpack_require__("qVQj")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Circle = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Circle = exports.Circle = function (_React$Component) {
    _inherits(Circle, _React$Component);

    function Circle() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Circle);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Circle.__proto__ || Object.getPrototypeOf(Circle)).call.apply(_ref, [this].concat(args))), _this), _this.centerChanged = function (newCenter) {
        var _this$props$center = _this.props.center,
            lat = _this$props$center.lat,
            lng = _this$props$center.lng;

        return lat !== newCenter.lat || lng !== newCenter.lng;
      }, _this.propsChanged = function (newProps) {
        if (_this.centerChanged(newProps.center)) return true;

        return Object.keys(Circle.propTypes).some(function (key) {
          return _this.props[key] !== newProps[key];
        });
      }, _this.destroyCircle = function () {
        if (_this.circle) {
          _this.circle.setMap(null);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Circle, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.circlePromise = wrappedPromise();
        this.renderCircle();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            path = _props.path,
            map = _props.map;


        if (this.propsChanged(prevProps) || map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(path, prevProps.path)) {
          this.destroyCircle();
          this.renderCircle();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.destroyCircle();
      }
    }, {
      key: 'renderCircle',
      value: function renderCircle() {
        var _this2 = this;

        var _props2 = this.props,
            map = _props2.map,
            google = _props2.google,
            center = _props2.center,
            radius = _props2.radius,
            strokeColor = _props2.strokeColor,
            strokeOpacity = _props2.strokeOpacity,
            strokeWeight = _props2.strokeWeight,
            fillColor = _props2.fillColor,
            fillOpacity = _props2.fillOpacity,
            draggable = _props2.draggable,
            visible = _props2.visible,
            props = _objectWithoutProperties(_props2, ['map', 'google', 'center', 'radius', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity', 'draggable', 'visible']);

        if (!google) {
          return null;
        }

        var params = _extends({}, props, {
          map: map,
          center: center,
          radius: radius,
          draggable: draggable,
          visible: visible,
          options: {
            strokeColor: strokeColor,
            strokeOpacity: strokeOpacity,
            strokeWeight: strokeWeight,
            fillColor: fillColor,
            fillOpacity: fillOpacity
          }
        });

        this.circle = new google.maps.Circle(params);

        evtNames.forEach(function (e) {
          _this2.circle.addListener(e, _this2.handleEvent(e));
        });

        this.circlePromise.resolve(this.circle);
      }
    }, {
      key: 'getCircle',
      value: function getCircle() {
        return this.circlePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.circle, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Circle;
  }(_react2.default.Component);

  Circle.propTypes = {
    center: _propTypes2.default.object,
    radius: _propTypes2.default.number,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number,
    draggable: _propTypes2.default.bool,
    visible: _propTypes2.default.bool
  };

  evtNames.forEach(function (e) {
    return Circle.propTypes[e] = _propTypes2.default.func;
  });

  Circle.defaultProps = {
    name: 'Circle'
  };

  exports.default = Circle;
});

/***/ }),

/***/ "bGGS":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("q1tI"), __webpack_require__("17x9"), __webpack_require__("ZZ2F"), __webpack_require__("qVQj")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polygon = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polygon = exports.Polygon = function (_React$Component) {
    _inherits(Polygon, _React$Component);

    function Polygon() {
      _classCallCheck(this, Polygon);

      return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
    }

    _createClass(Polygon, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polygonPromise = wrappedPromise();
        this.renderPolygon();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.paths, prevProps.paths)) {
          if (this.polygon) {
            this.polygon.setMap(null);
          }
          this.renderPolygon();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polygon) {
          this.polygon.setMap(null);
        }
      }
    }, {
      key: 'renderPolygon',
      value: function renderPolygon() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            paths = _props.paths,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            fillColor = _props.fillColor,
            fillOpacity = _props.fillOpacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'paths', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          paths: paths,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight,
          fillColor: fillColor,
          fillOpacity: fillOpacity
        }, props);

        this.polygon = new google.maps.Polygon(params);

        evtNames.forEach(function (e) {
          _this2.polygon.addListener(e, _this2.handleEvent(e));
        });

        this.polygonPromise.resolve(this.polygon);
      }
    }, {
      key: 'getPolygon',
      value: function getPolygon() {
        return this.polygonPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polygon, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polygon;
  }(_react2.default.Component);

  Polygon.propTypes = {
    paths: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polygon.propTypes[e] = _propTypes2.default.func;
  });

  Polygon.defaultProps = {
    name: 'Polygon'
  };

  exports.default = Polygon;
});

/***/ }),

/***/ "cTJO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _interopRequireWildcard = __webpack_require__("284h");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__("q1tI"));

var _router = __webpack_require__("elyg");

var _router2 = __webpack_require__("nOHt");

var _useIntersection = __webpack_require__("vNVm");

var prefetched = {};

function prefetch(router, href, as, options) {
  if (false) {}
  if (!(0, _router.isLocalURL)(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  router.prefetch(href, as, options).catch(function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || // triggers resource download
  event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
  var nodeName = e.currentTarget.nodeName;

  if (nodeName === 'A' && (isModifiedEvent(e) || !(0, _router.isLocalURL)(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault(); //  avoid scroll for urls with anchor refs

  if (scroll == null) {
    scroll = as.indexOf('#') < 0;
  } // replace state instead of push if prop is present


  router[replace ? 'replace' : 'push'](href, as, {
    shallow: shallow,
    locale: locale
  }).then(function (success) {
    if (!success) return;

    if (scroll) {
      window.scrollTo(0, 0);
      document.body.focus();
    }
  });
}

function Link(props) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var p = props.prefetch !== false;
  var router = (0, _router2.useRouter)();
  var pathname = router && router.pathname || '/';

  var _react$default$useMem = _react.default.useMemo(function () {
    var _ref = (0, _router.resolveHref)(pathname, props.href, true),
        _ref2 = _slicedToArray(_ref, 2),
        resolvedHref = _ref2[0],
        resolvedAs = _ref2[1];

    return {
      href: resolvedHref,
      as: props.as ? (0, _router.resolveHref)(pathname, props.as) : resolvedAs || resolvedHref
    };
  }, [pathname, props.href, props.as]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var children = props.children,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale; // Deprecated. Warning shown by propType check. If the children provided is a string (<Link>example</Link>) we wrap it in an <a> tag

  if (typeof children === 'string') {
    children = /*#__PURE__*/_react.default.createElement("a", null, children);
  } // This will return the first child, if multiple are provided it will throw an error


  var child = _react.Children.only(children);

  var childRef = child && typeof child === 'object' && child.ref;

  var _ref3 = (0, _useIntersection.useIntersection)({
    rootMargin: '200px'
  }),
      _ref4 = _slicedToArray(_ref3, 2),
      setIntersectionRef = _ref4[0],
      isVisible = _ref4[1];

  var setRef = _react.default.useCallback(function (el) {
    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [childRef, setIntersectionRef]);

  (0, _react.useEffect)(function () {
    var shouldPrefetch = isVisible && p && (0, _router.isLocalURL)(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);
  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale);
      }
    }
  };

  childProps.onMouseEnter = function (e) {
    if (!(0, _router.isLocalURL)(href)) return;

    if (child.props && typeof child.props.onMouseEnter === 'function') {
      child.props.onMouseEnter(e);
    }

    prefetch(router, href, as, {
      priority: true
    });
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user


  if (props.passHref || child.type === 'a' && !('href' in child.props)) {
    childProps.href = (0, _router.addBasePath)((0, _router.addLocale)(as, typeof locale !== 'undefined' ? locale : router && router.locale, router && router.defaultLocale));
  }

  return /*#__PURE__*/_react.default.cloneElement(child, childProps);
}

var _default = Link;
exports.default = _default;

/***/ }),

/***/ "ckIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5AJ6");


/* harmony default export */ __webpack_exports__["a"] = (Object(_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
}), 'AccountCircle'));

/***/ }),

/***/ "cvHD":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var GoogleApi = exports.GoogleApi = function GoogleApi(opts) {
    opts = opts || {};

    if (!opts.hasOwnProperty('apiKey')) {
      throw new Error('You must pass an apiKey to use GoogleApi');
    }

    var apiKey = opts.apiKey;
    var libraries = opts.libraries || ['places'];
    var client = opts.client;
    var URL = opts.url || 'https://maps.googleapis.com/maps/api/js';

    var googleVersion = opts.version || '3.31';

    var script = null;
    var google = typeof window !== 'undefined' && window.google || null;
    var loading = false;
    var channel = null;
    var language = opts.language;
    var region = opts.region || null;

    var onLoadEvents = [];

    var url = function url() {
      var url = URL;
      var params = {
        key: apiKey,
        callback: 'CALLBACK_NAME',
        libraries: libraries.join(','),
        client: client,
        v: googleVersion,
        channel: channel,
        language: language,
        region: region,
        onerror: 'ERROR_FUNCTION'
      };

      var paramStr = Object.keys(params).filter(function (k) {
        return !!params[k];
      }).map(function (k) {
        return k + '=' + params[k];
      }).join('&');

      return url + '?' + paramStr;
    };

    return url();
  };

  exports.default = GoogleApi;
});

/***/ }),

/***/ "dEHY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toBase64 = toBase64;
/**
* Isomorphic base64 that works on the server and client
*/

function toBase64(str) {
  if (false) {} else {
    return window.btoa(str);
  }
}

/***/ }),

/***/ "dQHF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _toConsumableArray = __webpack_require__("RIqP");

var _interopRequireDefault = __webpack_require__("TqRt");

exports.__esModule = true;
exports.default = Image;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("8OQS"));

var _extends2 = _interopRequireDefault(__webpack_require__("pVnL"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _toBase = __webpack_require__("dEHY");

var _imageConfig = __webpack_require__("UWYU");

var _useIntersection = __webpack_require__("vNVm");

if (false) {}

var VALID_LOADING_VALUES = ['lazy', 'eager', undefined];
var loaders = new Map([['imgix', imgixLoader], ['cloudinary', cloudinaryLoader], ['akamai', akamaiLoader], ['default', defaultLoader]]);
var VALID_LAYOUT_VALUES = ['fill', 'fixed', 'intrinsic', 'responsive', undefined];

var _ref2 = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default"} || _imageConfig.imageConfigDefault,
    configDeviceSizes = _ref2.deviceSizes,
    configImageSizes = _ref2.imageSizes,
    configLoader = _ref2.loader,
    configPath = _ref2.path,
    configDomains = _ref2.domains; // sort smallest to largest


var allSizes = [].concat(_toConsumableArray(configDeviceSizes), _toConsumableArray(configImageSizes));
configDeviceSizes.sort(function (a, b) {
  return a - b;
});
allSizes.sort(function (a, b) {
  return a - b;
});

function getWidths(width, layout) {
  if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
    return {
      widths: configDeviceSizes,
      kind: 'w'
    };
  }

  var widths = _toConsumableArray(new Set([width, width * 2, width * 3].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));

  return {
    widths: widths,
    kind: 'x'
  };
}

function callLoader(loaderProps) {
  var load = loaders.get(configLoader);

  if (load) {
    return load((0, _extends2.default)({
      root: configPath
    }, loaderProps));
  }

  throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(configLoader));
}

function generateImgAttrs(_ref3) {
  var src = _ref3.src,
      unoptimized = _ref3.unoptimized,
      layout = _ref3.layout,
      width = _ref3.width,
      quality = _ref3.quality,
      sizes = _ref3.sizes;

  if (unoptimized) {
    return {
      src: src
    };
  }

  var _getWidths = getWidths(width, layout),
      widths = _getWidths.widths,
      kind = _getWidths.kind;

  var last = widths.length - 1;
  var srcSet = widths.map(function (w, i) {
    return "".concat(callLoader({
      src: src,
      quality: quality,
      width: w
    }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
  }).join(', ');

  if (!sizes && kind === 'w') {
    sizes = '100vw';
  }

  src = callLoader({
    src: src,
    quality: quality,
    width: widths[last]
  });
  return {
    src: src,
    sizes: sizes,
    srcSet: srcSet
  };
}

function getInt(x) {
  if (typeof x === 'number') {
    return x;
  }

  if (typeof x === 'string') {
    return parseInt(x, 10);
  }

  return undefined;
}

function Image(_ref) {
  var src = _ref.src,
      sizes = _ref.sizes,
      _ref$unoptimized = _ref.unoptimized,
      unoptimized = _ref$unoptimized === void 0 ? false : _ref$unoptimized,
      _ref$priority = _ref.priority,
      priority = _ref$priority === void 0 ? false : _ref$priority,
      loading = _ref.loading,
      className = _ref.className,
      quality = _ref.quality,
      width = _ref.width,
      height = _ref.height,
      objectFit = _ref.objectFit,
      objectPosition = _ref.objectPosition,
      all = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["src", "sizes", "unoptimized", "priority", "loading", "className", "quality", "width", "height", "objectFit", "objectPosition"]);
  var rest = all;
  var layout = sizes ? 'responsive' : 'intrinsic';
  var unsized = false;

  if ('unsized' in rest) {
    unsized = Boolean(rest.unsized); // Remove property so it's not spread into image:

    delete rest['unsized'];
  } else if ('layout' in rest) {
    // Override default layout if the user specified one:
    if (rest.layout) layout = rest.layout; // Remove property so it's not spread into image:

    delete rest['layout'];
  }

  if (false) {}

  var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');

  if (src && src.startsWith('data:')) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }

  var _ref4 = (0, _useIntersection.useIntersection)({
    rootMargin: '200px',
    disabled: !isLazy
  }),
      _ref5 = _slicedToArray(_ref4, 2),
      setRef = _ref5[0],
      isIntersected = _ref5[1];

  var isVisible = !isLazy || isIntersected;
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var qualityInt = getInt(quality);
  var wrapperStyle;
  var sizerStyle;
  var sizerSvg;
  var imgStyle = {
    visibility: isVisible ? 'visible' : 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    boxSizing: 'border-box',
    padding: 0,
    border: 'none',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    objectFit: objectFit,
    objectPosition: objectPosition
  };

  if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined' && layout !== 'fill') {
    // <Image src="i.png" width="100" height="100" />
    var quotient = heightInt / widthInt;
    var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");

    if (layout === 'responsive') {
      // <Image src="i.png" width="100" height="100" layout="responsive" />
      wrapperStyle = {
        display: 'block',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        display: 'block',
        boxSizing: 'border-box',
        paddingTop: paddingTop
      };
    } else if (layout === 'intrinsic') {
      // <Image src="i.png" width="100" height="100" layout="intrinsic" />
      wrapperStyle = {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        boxSizing: 'border-box',
        display: 'block',
        maxWidth: '100%'
      };
      sizerSvg = "<svg width=\"".concat(widthInt, "\" height=\"").concat(heightInt, "\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\"/>");
    } else if (layout === 'fixed') {
      // <Image src="i.png" width="100" height="100" layout="fixed" />
      wrapperStyle = {
        overflow: 'hidden',
        boxSizing: 'border-box',
        display: 'inline-block',
        position: 'relative',
        width: widthInt,
        height: heightInt
      };
    }
  } else if (typeof widthInt === 'undefined' && typeof heightInt === 'undefined' && layout === 'fill') {
    // <Image src="i.png" layout="fill" />
    wrapperStyle = {
      display: 'block',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      boxSizing: 'border-box',
      margin: 0
    };
  } else {
    // <Image src="i.png" />
    if (false) {}
  }

  var imgAttributes = {
    src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  };

  if (isVisible) {
    imgAttributes = generateImgAttrs({
      src: src,
      unoptimized: unoptimized,
      layout: layout,
      width: widthInt,
      quality: qualityInt,
      sizes: sizes
    });
  }

  if (unsized) {
    wrapperStyle = undefined;
    sizerStyle = undefined;
    imgStyle = undefined;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: wrapperStyle
  }, sizerStyle ? /*#__PURE__*/_react.default.createElement("div", {
    style: sizerStyle
  }, sizerSvg ? /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxWidth: '100%',
      display: 'block'
    },
    alt: "",
    "aria-hidden": true,
    role: "presentation",
    src: "data:image/svg+xml;base64,".concat((0, _toBase.toBase64)(sizerSvg))
  }) : null) : null, /*#__PURE__*/_react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
    decoding: "async",
    className: className,
    ref: setRef,
    style: imgStyle
  })));
} //BUILT IN LOADERS


function normalizeSrc(src) {
  return src[0] === '/' ? src.slice(1) : src;
}

function imgixLoader(_ref6) {
  var root = _ref6.root,
      src = _ref6.src,
      width = _ref6.width,
      quality = _ref6.quality;
  // Demo: https://static.imgix.net/daisy.png?format=auto&fit=max&w=300
  var params = ['auto=format', 'fit=max', 'w=' + width];
  var paramsString = '';

  if (quality) {
    params.push('q=' + quality);
  }

  if (params.length) {
    paramsString = '?' + params.join('&');
  }

  return "".concat(root).concat(normalizeSrc(src)).concat(paramsString);
}

function akamaiLoader(_ref7) {
  var root = _ref7.root,
      src = _ref7.src,
      width = _ref7.width;
  return "".concat(root).concat(normalizeSrc(src), "?imwidth=").concat(width);
}

function cloudinaryLoader(_ref8) {
  var root = _ref8.root,
      src = _ref8.src,
      width = _ref8.width,
      quality = _ref8.quality;
  // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
  var params = ['f_auto', 'c_limit', 'w_' + width, 'q_' + (quality || 'auto')];
  var paramsString = params.join(',') + '/';
  return "".concat(root).concat(paramsString).concat(normalizeSrc(src));
}

function defaultLoader(_ref9) {
  var root = _ref9.root,
      src = _ref9.src,
      width = _ref9.width,
      quality = _ref9.quality;

  if (false) { var parsedSrc, missingValues; }

  return "".concat(root, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}

/***/ }),

/***/ "eQk5":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("q1tI"), __webpack_require__("17x9"), __webpack_require__("ZZ2F"), __webpack_require__("qVQj")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polyline = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polyline = exports.Polyline = function (_React$Component) {
    _inherits(Polyline, _React$Component);

    function Polyline() {
      _classCallCheck(this, Polyline);

      return _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).apply(this, arguments));
    }

    _createClass(Polyline, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polylinePromise = wrappedPromise();
        this.renderPolyline();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.path, prevProps.path)) {
          if (this.polyline) {
            this.polyline.setMap(null);
          }
          this.renderPolyline();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polyline) {
          this.polyline.setMap(null);
        }
      }
    }, {
      key: 'renderPolyline',
      value: function renderPolyline() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            path = _props.path,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            props = _objectWithoutProperties(_props, ['map', 'google', 'path', 'strokeColor', 'strokeOpacity', 'strokeWeight']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          path: path,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight
        }, props);

        this.polyline = new google.maps.Polyline(params);

        evtNames.forEach(function (e) {
          _this2.polyline.addListener(e, _this2.handleEvent(e));
        });

        this.polylinePromise.resolve(this.polyline);
      }
    }, {
      key: 'getPolyline',
      value: function getPolyline() {
        return this.polylinePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polyline, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polyline;
  }(_react2.default.Component);

  Polyline.propTypes = {
    path: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polyline.propTypes[e] = _propTypes2.default.func;
  });

  Polyline.defaultProps = {
    name: 'Polyline'
  };

  exports.default = Polyline;
});

/***/ }),

/***/ "fcsG":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("q1tI"), __webpack_require__("17x9"), __webpack_require__("i8i4"), __webpack_require__("KAy6")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes, _reactDom, _server) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.InfoWindow = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _server2 = _interopRequireDefault(_server);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InfoWindow = exports.InfoWindow = function (_React$Component) {
    _inherits(InfoWindow, _React$Component);

    function InfoWindow() {
      _classCallCheck(this, InfoWindow);

      return _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).apply(this, arguments));
    }

    _createClass(InfoWindow, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.renderInfoWindow();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            google = _props.google,
            map = _props.map;


        if (!google || !map) {
          return;
        }

        if (map !== prevProps.map) {
          this.renderInfoWindow();
        }

        if (this.props.position !== prevProps.position) {
          this.updatePosition();
        }

        if (this.props.children !== prevProps.children) {
          this.updateContent();
        }

        if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker || this.props.position !== prevProps.position) {
          this.props.visible ? this.openWindow() : this.closeWindow();
        }
      }
    }, {
      key: 'renderInfoWindow',
      value: function renderInfoWindow() {
        var _props2 = this.props,
            map = _props2.map,
            google = _props2.google,
            mapCenter = _props2.mapCenter,
            props = _objectWithoutProperties(_props2, ['map', 'google', 'mapCenter']);

        if (!google || !google.maps) {
          return;
        }

        var iw = this.infowindow = new google.maps.InfoWindow(_extends({
          content: ''
        }, props));

        google.maps.event.addListener(iw, 'closeclick', this.onClose.bind(this));
        google.maps.event.addListener(iw, 'domready', this.onOpen.bind(this));
      }
    }, {
      key: 'onOpen',
      value: function onOpen() {
        if (this.props.onOpen) {
          this.props.onOpen();
        }
      }
    }, {
      key: 'onClose',
      value: function onClose() {
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
    }, {
      key: 'openWindow',
      value: function openWindow() {
        this.infowindow.open(this.props.map, this.props.marker);
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition() {
        var pos = this.props.position;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = pos && new google.maps.LatLng(pos.lat, pos.lng);
        }
        this.infowindow.setPosition(pos);
      }
    }, {
      key: 'updateContent',
      value: function updateContent() {
        var content = this.renderChildren();
        this.infowindow.setContent(content);
      }
    }, {
      key: 'closeWindow',
      value: function closeWindow() {
        this.infowindow.close();
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var children = this.props.children;

        return _server2.default.renderToString(children);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return InfoWindow;
  }(_react2.default.Component);

  InfoWindow.propTypes = {
    children: _propTypes2.default.element.isRequired,
    map: _propTypes2.default.object,
    marker: _propTypes2.default.object,
    position: _propTypes2.default.object,
    visible: _propTypes2.default.bool,

    // callbacks
    onClose: _propTypes2.default.func,
    onOpen: _propTypes2.default.func
  };

  InfoWindow.defaultProps = {
    visible: false
  };

  exports.default = InfoWindow;
});

/***/ }),

/***/ "gFoV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vOnD");
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("BlcV");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var Title = styled_components__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"].h3.withConfig({
  displayName: "DefaultTitle__Title",
  componentId: "rf6gx3-0"
})(["color:", ";font-family:", ";font-size:", ";margin:", ";overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"], function (props) {
  return props.color ? props.color : "black";
}, _globals__WEBPACK_IMPORTED_MODULE_4__[/* FONTS */ "b"].family.robotoslab_bold, function (props) {
  return props.size ? props.size : "30px";
}, function (props) {
  return props.margin ? props.margin : "0";
});

var DefaultTitle = function DefaultTitle(_ref) {
  var children = _ref.children,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children"]);

  return __jsx(Title, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    "data-testid": "default-title-component"
  }), children);
};

DefaultTitle.defaultProps = {
  children: ""
};
/* harmony default export */ __webpack_exports__["a"] = (DefaultTitle);

/***/ }),

/***/ "jmHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_events_useEventListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("M6j1");
/* harmony import */ var _atoms_GoogleMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("w+tp");
/* harmony import */ var _molecules_BannerInfoCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("q9b2");

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var MapCard = function MapCard(_ref) {
  var coords = _ref.coords,
      callback = _ref.callback;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      layoutMobile = _useState[0],
      setLayouyMobile = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    setLayouyMobile(window.innerWidth <= 600);
  }, []);
  var handleResize = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
    if (window.innerWidth > 600) {
      if (layoutMobile) {
        setLayouyMobile(false);
      }
    } else if (!layoutMobile) {
      setLayouyMobile(true);
    }
  }, [layoutMobile, setLayouyMobile]);
  Object(_hooks_events_useEventListener__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])("resize", handleResize);
  return __jsx(_molecules_BannerInfoCard__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
    actionText: "Ver Mapa",
    actionCallback: callback,
    cardW: layoutMobile ? "320px" : "420px",
    cardH: layoutMobile ? "190px" : "250px",
    border: "20px",
    bannerNode: __jsx(_atoms_GoogleMap__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
      width: "100%",
      height: "100%",
      coords: coords
    }),
    bannerH: layoutMobile ? "125px" : "185px"
  });
};

/* harmony default export */ __webpack_exports__["a"] = (MapCard);

/***/ }),

/***/ "kq0K":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  /**
   * Compares two bound objects.
   */

  var areBoundsEqual = exports.areBoundsEqual = function areBoundsEqual(boundA, boundB) {
    if (boundA === boundB) {
      return true;
    }
    if (!(boundA instanceof Object) || !(boundB instanceof Object)) {
      return false;
    }
    if (Object.keys(boundA).length !== Object.keys(boundB).length) {
      return false;
    }
    if (!areValidBounds(boundA) || !areValidBounds(boundB)) {
      return false;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(boundA)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (boundA[key] !== boundB[key]) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  };

  /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */
  var areValidBounds = function areValidBounds(elem) {
    return elem !== null && (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object' && elem.hasOwnProperty('north') && elem.hasOwnProperty('south') && elem.hasOwnProperty('east') && elem.hasOwnProperty('west');
  };
});

/***/ }),

/***/ "l6Rm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// CONCATENATED MODULE: ./src/atomic/atoms/ImageFrame/styles.js

var Frame = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Frame",
  componentId: "lojtv0-0"
})(["background:", ";width:", ";height:", ";margin:", ";border:", ";border-radius:", ";position:relative;overflow:hidden;@media only screen and (max-width:900px){", " ", "}"], function (props) {
  return props.background ? props.background : "";
}, function (props) {
  return props.widthDesktop ? props.widthDesktop : "100%";
}, function (props) {
  return props.heightDesktop ? props.heightDesktop : "max-content";
}, function (props) {
  return props.margin ? props.margin : "0";
}, function (props) {
  return props.border ? props.border : "none";
}, function (props) {
  return props.borderRadius ? props.borderRadius : "0";
}, function (props) {
  return !!props.widthMobile && Object(styled_components_browser_esm["a" /* css */])(["width:", ";"], props.widthMobile);
}, function (props) {
  return !!props.heightMobile && Object(styled_components_browser_esm["a" /* css */])(["height:", ";"], props.heightMobile);
});
var Image = styled_components_browser_esm["b" /* default */].img.withConfig({
  displayName: "styles__Image",
  componentId: "lojtv0-1"
})(["", " width:", ";height:", ";"], function (props) {
  return props.absolute ? "\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%,-50%);\n            " : "";
}, function (props) {
  return props.width ? props.width : "100%";
}, function (props) {
  return props.height ? props.height : "100%";
});
var Container = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Container",
  componentId: "lojtv0-2"
})(["position:relative;width:", ";height:", ";"], function (props) {
  return props.width ? props.width : "100%";
}, function (props) {
  return props.height ? props.height : "100%";
});
// CONCATENATED MODULE: ./src/atomic/atoms/ImageFrame/index.js



var __jsx = react_default.a.createElement;



var ImageFrame_ImageFrame = function ImageFrame(_ref) {
  var src = _ref.src,
      children = _ref.children,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["src", "children"]);

  var _useState = Object(react["useState"])(null),
      frRef = _useState[0],
      setFrRef = _useState[1];

  var _useState2 = Object(react["useState"])(null),
      imgRef = _useState2[0],
      setImgRef = _useState2[1];

  var _useState3 = Object(react["useState"])(null),
      imgSrc = _useState3[0],
      setImgSrc = _useState3[1];

  Object(react["useEffect"])(function () {
    var observer;
    var didCancel = false;

    if (imgRef && imgSrc === null && !!src) {
      if (IntersectionObserver) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // when image is visible in the viewport + rootMargin
            if (!didCancel && (entry.intersectionRatio > 0 || entry.isIntersecting)) {
              setImgSrc(src);
              observer.unobserve(imgRef);
            }
          });
        }, {
          threshold: 0.01,
          rootMargin: "30px"
        });
        observer.observe(imgRef);
      } else {
        // Old browsers fallback
        setImgSrc(src);
      }
    }

    if (imgSrc !== null && imgSrc !== src) {
      setImgSrc(src);
    }

    return function () {
      var _observer;

      didCancel = true;

      if ((_observer = observer) === null || _observer === void 0 ? void 0 : _observer.unobserve) {
        observer.unobserve(imgRef);
      }
    };
  }, [src, imgSrc, imgRef]);

  var handleLoad = function handleLoad(e) {
    if (rest.adjust) {
      var frRatio = frRef.innerHeight / frRef.innerWidth;
      var imgRatio = e.target.naturalHeight / e.target.naturalWidth;
      var width;
      var height;

      if (imgRatio >= frRatio) {
        width = "auto";
        height = "100%";
      } else {
        width = "100%";
        height = "auto";
      }

      e.target.style.width = width;
      e.target.style.height = height;
    }
  };

  var background = rest.background,
      frW = rest.frW,
      frH = rest.frH,
      frWMobile = rest.frWMobile,
      frHMobile = rest.frHMobile,
      margin = rest.margin,
      border = rest.border,
      radius = rest.radius,
      absolute = rest.absolute,
      imgW = rest.imgW,
      imgH = rest.imgH,
      REST = Object(objectWithoutProperties["a" /* default */])(rest, ["background", "frW", "frH", "frWMobile", "frHMobile", "margin", "border", "radius", "absolute", "imgW", "imgH"]);

  var frameProps = {
    backgroundColor: background,
    widthDesktop: frW,
    heightDesktop: frH,
    widthMobile: frWMobile,
    heightMobile: frHMobile,
    margin: margin,
    border: border,
    radius: radius
  };
  var imageProps = {
    absolute: absolute,
    width: imgW,
    height: imgH
  };
  return __jsx(Frame, Object(esm_extends["a" /* default */])({
    ref: setFrRef
  }, frameProps, REST, {
    "data-testid": "image-frame-component"
  }), src && frRef && __jsx(Image, Object(esm_extends["a" /* default */])({
    ref: setImgRef,
    src: imgSrc,
    alt: "image",
    onLoad: handleLoad
  }, imageProps, {
    "data-testid": "image-component"
  })), children && __jsx(Container, null, children));
};

ImageFrame_ImageFrame.defaultProps = {
  src: null,
  absolute: null,
  adjust: null,
  background: null,
  margin: null,
  border: null,
  radius: null,
  frW: null,
  frH: null,
  frWMobile: null,
  frHMobile: null,
  imgW: null,
  imgH: null,
  children: null
};
/* harmony default export */ var atoms_ImageFrame = __webpack_exports__["a"] = (ImageFrame_ImageFrame);

/***/ }),

/***/ "pVnL":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ "q9b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__("wb2y");

// EXTERNAL MODULE: ./src/atomic/atoms/DefaultCard/index.js
var DefaultCard = __webpack_require__("PcuG");

// EXTERNAL MODULE: ./src/atomic/atoms/DefaultTitle/index.js
var DefaultTitle = __webpack_require__("gFoV");

// EXTERNAL MODULE: ./src/atomic/atoms/ImageFrame/index.js + 1 modules
var ImageFrame = __webpack_require__("l6Rm");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// CONCATENATED MODULE: ./src/atomic/molecules/BannerInfoCard/styles.js

var ContentContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__ContentContainer",
  componentId: "sc-1hxx7qp-0"
})(["width:auto;flex-grow:1;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;margin:0px 10px;text-align:center;overflow:hidden;"]);
var LogoContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__LogoContainer",
  componentId: "sc-1hxx7qp-1"
})(["background:#ffffff;position:absolute;top:", ";left:50%;transform:translate(-50%,-50%);width:", ";height:", ";border-radius:20px;box-shadow:0 24.4px 29.9px 0 rgba(0,0,0,0.04);display:flex;flex-direction:column;justify-content:center;align-items:center;z-index:10;overflow:hidden;& img{width:100%;height:100%;}& p{color:#9cafd9;font-family:Roboto Black;font-size:24px;font-weight:bold;}"], function (props) {
  return props.bannerH ? props.bannerH : "0";
}, function (props) {
  return props.size ? props.size : "120px";
}, function (props) {
  return props.size ? props.size : "120px";
});
var ActionContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__ActionContainer",
  componentId: "sc-1hxx7qp-2"
})(["width:100%;height:65px;display:flex;flex-direction:row;justify-content:center;align-items:center;"]);
var Action = styled_components_browser_esm["b" /* default */].p.withConfig({
  displayName: "styles__Action",
  componentId: "sc-1hxx7qp-3"
})(["cursor:pointer;color:#1767f5;font-family:Roboto Medium;font-size:16px;font-weight:bold;"]);
var WrapperTitle = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__WrapperTitle",
  componentId: "sc-1hxx7qp-4"
})(["display:block;overflow:hidden;"]);
// CONCATENATED MODULE: ./src/atomic/molecules/BannerInfoCard/index.js

var __jsx = react_default.a.createElement;






var BannerInfoCard_BannerInfoCard = function BannerInfoCard(_ref) {
  var title = _ref.title,
      actionText = _ref.actionText,
      actionCallback = _ref.actionCallback,
      cardW = _ref.cardW,
      cardH = _ref.cardH,
      border = _ref.border,
      bannerSrc = _ref.bannerSrc,
      bannerNode = _ref.bannerNode,
      bannerH = _ref.bannerH,
      logoSrc = _ref.logoSrc,
      logoText = _ref.logoText,
      logoSize = _ref.logoSize,
      children = _ref.children;
  var titleMargin = (logoSize ? parseInt(logoSize.match(/(\d+)px/)[1]) / 2 : 0) + 20;
  return __jsx(DefaultCard["a" /* default */], {
    shadow: "true",
    width: cardW,
    height: cardH,
    radius: border
  }, __jsx(ImageFrame["a" /* default */], {
    src: bannerSrc,
    frH: bannerH,
    borderRadius: "20px"
  }, bannerNode), __jsx(ContentContainer, null, title && __jsx(WrapperTitle, null, __jsx(DefaultTitle["a" /* default */], {
    size: "20px",
    margin: "".concat(titleMargin, "px 0 20px 0")
  }, title)), children), (title || children) && __jsx(Divider["a" /* default */], null), __jsx(ActionContainer, null, __jsx(Action, {
    onClick: actionCallback
  }, actionText)), (logoSrc || logoText) && __jsx(LogoContainer, {
    size: logoSize,
    bannerH: bannerH
  }, logoSrc && __jsx("img", {
    src: logoSrc,
    alt: "logo"
  }), logoText && __jsx("p", null, logoText)));
};

BannerInfoCard_BannerInfoCard.defaultProps = {
  actionText: "Action"
};
/* harmony default export */ var molecules_BannerInfoCard = __webpack_exports__["a"] = (BannerInfoCard_BannerInfoCard);

/***/ }),

/***/ "qVQj":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var camelize = exports.camelize = function camelize(str) {
    return str.split('_').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('');
  };
});

/***/ }),

/***/ "vNVm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _interopRequireDefault = __webpack_require__("TqRt");

exports.__esModule = true;
exports.useIntersection = useIntersection;

var _react = __webpack_require__("q1tI");

var _requestIdleCallback = _interopRequireDefault(__webpack_require__("0G5g"));

var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';

function useIntersection(_ref) {
  var rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;
  var unobserve = (0, _react.useRef)();

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      visible = _ref3[0],
      setVisible = _ref3[1];

  var setRef = (0, _react.useCallback)(function (el) {
    if (unobserve.current) {
      unobserve.current();
      unobserve.current = undefined;
    }

    if (isDisabled || visible) return;

    if (el && el.tagName) {
      unobserve.current = observe(el, function (isVisible) {
        return isVisible && setVisible(isVisible);
      }, {
        rootMargin: rootMargin
      });
    }
  }, [isDisabled, rootMargin, visible]);
  (0, _react.useEffect)(function () {
    if (!hasIntersectionObserver) {
      if (!visible) (0, _requestIdleCallback.default)(function () {
        return setVisible(true);
      });
    }
  }, [visible]);
  return [setRef, visible];
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
    }
  };
}

var observers = new Map();

function createObserver(options) {
  var id = options.rootMargin || '';
  var instance = observers.get(id);

  if (instance) {
    return instance;
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  observers.set(id, instance = {
    id: id,
    observer: observer,
    elements: elements
  });
  return instance;
}

/***/ }),

/***/ "vXff":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("yjrR")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else { var mod; }
})(this, function (exports, window) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var counter = 0;
    var scriptMap = typeof window !== 'undefined' && window._scriptMap || new Map();
    var ScriptCache = exports.ScriptCache = function (global) {
        global._scriptMap = global._scriptMap || scriptMap;
        return function ScriptCache(scripts) {
            var Cache = {};

            Cache._onLoad = function (key) {
                return function (cb) {
                    var registered = true;

                    function unregister() {
                        registered = false;
                    }

                    var stored = scriptMap.get(key);

                    if (stored) {
                        stored.promise.then(function () {
                            if (registered) {
                                stored.error ? cb(stored.error) : cb(null, stored);
                            }

                            return stored;
                        }).catch(function (error) {
                            return cb(error);
                        });
                    } else {
                        // TODO:
                    }

                    return unregister;
                };
            };

            Cache._scriptTag = function (key, src) {
                if (!scriptMap.has(key)) {
                    // Server side rendering environments don't always have access to the `document` global.
                    // In these cases, we're not going to be able to return a script tag, so just return null.
                    if (typeof document === 'undefined') return null;

                    var tag = document.createElement('script');
                    var promise = new Promise(function (resolve, reject) {
                        var body = document.getElementsByTagName('body')[0];

                        tag.type = 'text/javascript';
                        tag.async = false; // Load in order

                        var cbName = 'loaderCB' + counter++ + Date.now();
                        var cb = void 0;

                        var handleResult = function handleResult(state) {
                            return function (evt) {
                                var stored = scriptMap.get(key);
                                if (state === 'loaded') {
                                    stored.resolved = true;
                                    resolve(src);
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = []
                                } else if (state === 'error') {
                                    stored.errored = true;
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = [];
                                    reject(evt);
                                }
                                stored.loaded = true;

                                cleanup();
                            };
                        };

                        var cleanup = function cleanup() {
                            if (global[cbName] && typeof global[cbName] === 'function') {
                                global[cbName] = null;
                                delete global[cbName];
                            }
                        };

                        tag.onload = handleResult('loaded');
                        tag.onerror = handleResult('error');
                        tag.onreadystatechange = function () {
                            handleResult(tag.readyState);
                        };

                        // Pick off callback, if there is one
                        if (src.match(/callback=CALLBACK_NAME/)) {
                            src = src.replace(/(callback=)[^\&]+/, '$1' + cbName);
                            cb = window[cbName] = tag.onload;
                        } else {
                            tag.addEventListener('load', tag.onload);
                        }
                        tag.addEventListener('error', tag.onerror);

                        tag.src = src;
                        body.appendChild(tag);

                        return tag;
                    });
                    var initialState = {
                        loaded: false,
                        error: false,
                        promise: promise,
                        tag: tag
                    };
                    scriptMap.set(key, initialState);
                }
                return scriptMap.get(key).tag;
            };

            // let scriptTags = document.querySelectorAll('script')
            //
            // NodeList.prototype.filter = Array.prototype.filter;
            // NodeList.prototype.map = Array.prototype.map;
            // const initialScripts = scriptTags
            //   .filter(s => !!s.src)
            //   .map(s => s.src.split('?')[0])
            //   .reduce((memo, script) => {
            //     memo[script] = script;
            //     return memo;
            //   }, {});

            Object.keys(scripts).forEach(function (key) {
                var script = scripts[key];

                var tag = window._scriptMap.has(key) ? window._scriptMap.get(key).tag : Cache._scriptTag(key, script);

                Cache[key] = {
                    tag: tag,
                    onLoad: Cache._onLoad(key)
                };
            });

            return Cache;
        };
    }(window);

    exports.default = ScriptCache;
});

/***/ }),

/***/ "w+tp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var google_maps_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("+567");
/* harmony import */ var google_maps_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(google_maps_react__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var GoogleMap = function GoogleMap(_ref) {
  var width = _ref.width,
      height = _ref.height,
      coords = _ref.coords,
      google = _ref.google,
      markerList = _ref.markerList,
      onClickMap = _ref.onClickMap,
      onDragstartMap = _ref.onDragstartMap,
      onDragendMap = _ref.onDragendMap,
      onZoomMap = _ref.onZoomMap,
      onClickMarker = _ref.onClickMarker,
      onMouseoverMarker = _ref.onMouseoverMarker;
  var renderMarkers = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
    return markerList.map(function (marker, idx) {
      return __jsx(google_maps_react__WEBPACK_IMPORTED_MODULE_1__["Marker"], {
        key: idx,
        name: marker.name,
        position: marker.coords,
        icon: marker.pinIcon ? {
          url: marker.pinIcon,
          scaledSize: new google.maps.Size(35, 35)
        } : null,
        onMouseover: function onMouseover(props, markerRef, e) {
          return onMouseoverMarker ? onMouseoverMarker(props, markerRef, e, marker.payload) : null;
        },
        onClick: function onClick(props, markerRef, e) {
          return onClickMarker ? onClickMarker(props, markerRef, e, marker.payload) : null;
        }
      });
    });
  }, [google, markerList, onClickMarker, onMouseoverMarker]);
  return __jsx(google_maps_react__WEBPACK_IMPORTED_MODULE_1__["Map"], {
    containerStyle: {
      width: width,
      height: height
    },
    initialCenter: coords,
    google: google,
    zoom: 15,
    fullscreenControl: false,
    onClick: function onClick(props, e) {
      return onClickMap ? onClickMap(props, e) : null;
    },
    onDragstart: function onDragstart(props, e) {
      return onDragstartMap ? onDragstartMap(props, e) : null;
    },
    onDragend: function onDragend(props, e) {
      return onDragendMap ? onDragendMap(props, e) : null;
    },
    onZoomChanged: function onZoomChanged(props, e) {
      return onZoomMap ? onZoomMap(props, e) : null;
    }
  }, renderMarkers);
};

GoogleMap.defaultProps = {
  markerList: [],
  coords: {
    lat: -23.498934,
    lng: -46.625435
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(google_maps_react__WEBPACK_IMPORTED_MODULE_1__["GoogleApiWrapper"])({
  apiKey: "AIzaSyD4BJV-u9OzkDAgqkIEKiTatn5_sFs13Dk",
  language: "PT-BR"
})(GoogleMap));

/***/ }),

/***/ "wb2y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("17x9");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("iuhU");
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("H2TA");
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ye/S");







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: Object(_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_6__[/* fade */ "c"])(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: '100%',
      width: 1
    },

    /* Styles applied to the root element if `flexItem={true}`. */
    flexItem: {
      alignSelf: 'stretch',
      height: 'auto'
    }
  };
};
var Divider = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["forwardRef"](function Divider(props, ref) {
  var _props$absolute = props.absolute,
      absolute = _props$absolute === void 0 ? false : _props$absolute,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'hr' : _props$component,
      _props$flexItem = props.flexItem,
      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$role = props.role,
      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
      other = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["createElement"](Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: Object(clsx__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
    role: role,
    ref: ref
  }, other));
});
 false ? undefined : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(styles, {
  name: 'MuiDivider'
})(Divider));

/***/ }),

/***/ "y8Bd":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("q1tI"), __webpack_require__("i8i4"), __webpack_require__("vXff"), __webpack_require__("cvHD")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _reactDom, _ScriptCache, _GoogleApi) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.wrapper = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _GoogleApi2 = _interopRequireDefault(_GoogleApi);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var defaultMapConfig = {};

  var serialize = function serialize(obj) {
    return JSON.stringify(obj);
  };
  var isSame = function isSame(obj1, obj2) {
    return obj1 === obj2 || serialize(obj1) === serialize(obj2);
  };

  var defaultCreateCache = function defaultCreateCache(options) {
    options = options || {};
    var apiKey = options.apiKey;
    var libraries = options.libraries || ['places'];
    var version = options.version || '3';
    var language = options.language || 'en';
    var url = options.url;
    var client = options.client;
    var region = options.region;

    return (0, _ScriptCache.ScriptCache)({
      google: (0, _GoogleApi2.default)({
        apiKey: apiKey,
        language: language,
        libraries: libraries,
        version: version,
        url: url,
        client: client,
        region: region
      })
    });
  };

  var DefaultLoadingContainer = function DefaultLoadingContainer(props) {
    return _react2.default.createElement(
      'div',
      null,
      'Loading...'
    );
  };

  var wrapper = exports.wrapper = function wrapper(input) {
    return function (WrappedComponent) {
      var Wrapper = function (_React$Component) {
        _inherits(Wrapper, _React$Component);

        function Wrapper(props, context) {
          _classCallCheck(this, Wrapper);

          // Build options from input
          var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));

          var options = typeof input === 'function' ? input(props) : input;

          // Initialize required Google scripts and other configured options
          _this.initialize(options);

          _this.state = {
            loaded: false,
            map: null,
            google: null,
            options: options
          };

          _this.mapRef = _react2.default.createRef();
          return _this;
        }

        _createClass(Wrapper, [{
          key: 'UNSAFE_componentWillReceiveProps',
          value: function UNSAFE_componentWillReceiveProps(props) {
            // Do not update input if it's not dynamic
            if (typeof input !== 'function') {
              return;
            }

            // Get options to compare
            var prevOptions = this.state.options;
            var options = typeof input === 'function' ? input(props) : input;

            // Ignore when options are not changed
            if (isSame(options, prevOptions)) {
              return;
            }

            // Initialize with new options
            this.initialize(options);

            // Save new options in component state,
            // and remove information about previous API handlers
            this.setState({
              options: options,
              loaded: false,
              google: null
            });
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.unregisterLoadHandler) {
              this.unregisterLoadHandler();
            }
          }
        }, {
          key: 'initialize',
          value: function initialize(options) {
            // Avoid race condition: remove previous 'load' listener
            if (this.unregisterLoadHandler) {
              this.unregisterLoadHandler();
              this.unregisterLoadHandler = null;
            }

            // Load cache factory
            var createCache = options.createCache || defaultCreateCache;

            // Build script
            this.scriptCache = createCache(options);
            this.unregisterLoadHandler = this.scriptCache.google.onLoad(this.onLoad.bind(this));

            // Store information about loading container
            this.LoadingContainer = options.LoadingContainer || DefaultLoadingContainer;
          }
        }, {
          key: 'onLoad',
          value: function onLoad(err, tag) {
            this._gapi = window.google;

            this.setState({ loaded: true, google: this._gapi });
          }
        }, {
          key: 'render',
          value: function render() {
            var LoadingContainer = this.LoadingContainer;

            if (!this.state.loaded) {
              return _react2.default.createElement(LoadingContainer, null);
            }

            var props = Object.assign({}, this.props, {
              loaded: this.state.loaded,
              google: window.google
            });

            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(WrappedComponent, props),
              _react2.default.createElement('div', { ref: this.mapRef })
            );
          }
        }]);

        return Wrapper;
      }(_react2.default.Component);

      return Wrapper;
    };
  };

  exports.default = wrapper;
});

/***/ }),

/***/ "yjrR":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (module) {
  'use strict';

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  module.exports = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || undefined;
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("3r9c")))

/***/ })

}]);